// Excel arac verileri — Alfa Romeo 2000+ ana veri taslagindan otomatik uretildi
export const EXCEL_VEHICLES = {
 "ALFA ROMEO": {
  "147": {
   "yil": 2000,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "IMPRESSION",
    "BLACKLINE",
    "COLLEZIONE",
    "SPECIALE"
   ],
   "kasa": [
    "HATCHBACK 3",
    "5 KAPI"
   ],
   "motor": [
    "1.6 TWIN SPARK",
    "2.0 TWIN SPARK",
    "1.9 JTD",
    "1.9 JTDM"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "SELESPEED"
   ]
  },
  "156": {
   "yil": 2000,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "IMPRESSION",
    "SPORTWAGON",
    "GTA"
   ],
   "kasa": [
    "SEDAN",
    "SPORTWAGON"
   ],
   "motor": [
    "1.6 TWIN SPARK",
    "1.8 TWIN SPARK",
    "2.0 TWIN SPARK",
    "2.5 V6",
    "1.9 JTD",
    "2.4 JTD"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "SELESPEED",
    "OTOMATIK"
   ]
  },
  "166": {
   "yil": 2000,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "SPORTRONIC",
    "SUPER"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 TWIN SPARK",
    "2.0 V6 TURBO",
    "2.4 JTD",
    "2.5 V6",
    "3.0 V6",
    "3.2 V6"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "SPORTRONIC OTOMATIK"
   ]
  },
  "GTV": {
   "yil": 2000,
   "paket": [
    "L",
    "LUSSO",
    "DISTINCTIVE",
    "CUP"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TWIN SPARK",
    "3.0 V6",
    "3.2 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "SELESPEED"
   ]
  },
  "SPIDER": {
   "yil": 2000,
   "paket": [
    "L",
    "LUSSO",
    "DISTINCTIVE",
    "VELOCE"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "2.0 TWIN SPARK",
    "3.0 V6",
    "3.2 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "SELESPEED"
   ]
  },
  "GT": {
   "yil": 2004,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "BLACKLINE",
    "COLLEZIONE"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "1.8 TWIN SPARK",
    "2.0 JTS",
    "3.2 V6",
    "1.9 JTDM"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "SELESPEED"
   ]
  },
  "159": {
   "yil": 2005,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "DISTINCTIVE PLUS",
    "TI"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.8 MPI",
    "1.9 JTS",
    "2.2 JTS",
    "3.2 JTS V6",
    "1.9 JTDM",
    "2.0 JTDM",
    "2.4 JTDM"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "Q-TRONIC OTOMATIK"
   ]
  },
  "159 SPORTWAGON": {
   "yil": 2006,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "DISTINCTIVE PLUS",
    "TI"
   ],
   "kasa": [
    "STATION WAGON"
   ],
   "motor": [
    "1.8 MPI",
    "1.9 JTS",
    "2.2 JTS",
    "3.2 JTS V6",
    "1.9 JTDM",
    "2.0 JTDM",
    "2.4 JTDM"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "Q-TRONIC OTOMATIK"
   ]
  },
  "BRERA": {
   "yil": 2006,
   "paket": [
    "SKY VIEW",
    "DISTINCTIVE",
    "TI"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.2 JTS",
    "3.2 JTS V6",
    "2.0 JTDM",
    "2.4 JTDM"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "SELESPEED",
    "Q-TRONIC"
   ]
  },
  "BRERA SPIDER": {
   "yil": 2006,
   "paket": [
    "SKY VIEW",
    "DISTINCTIVE",
    "TI"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "2.2 JTS",
    "3.2 JTS V6",
    "2.4 JTDM"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "SELESPEED",
    "Q-TRONIC"
   ]
  },
  "8C COMPETIZIONE": {
   "yil": 2007,
   "paket": [
    "8C COMPETIZIONE"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "4.7 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 ILERI ROBOTIZE"
   ]
  },
  "8C SPIDER": {
   "yil": 2008,
   "paket": [
    "8C SPIDER"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "4.7 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 ILERI ROBOTIZE"
   ]
  },
  "MITO": {
   "yil": 2008,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "TURISMO",
    "SPRINT",
    "SUPER",
    "VELOCE",
    "QUADRIFOGLIO VERDE"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.4 8V",
    "1.4 MULTIAIR",
    "0.9 TWINAIR",
    "1.3 JTDM",
    "1.6 JTDM",
    "1.4 TB MULTIAIR"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "TCT",
    "SELESPEED"
   ]
  },
  "GIULIETTA": {
   "yil": 2010,
   "paket": [
    "PROGRESSION",
    "DISTINCTIVE",
    "SPORTIVA",
    "SPRINT",
    "SUPER",
    "VELOCE",
    "QUADRIFOGLIO VERDE",
    "SPECIALE"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.4 TB",
    "1.4 TB MULTIAIR",
    "1.75 TBI",
    "1.6 JTDM",
    "2.0 JTDM"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "TCT"
   ]
  },
  "4C": {
   "yil": 2013,
   "paket": [
    "4C",
    "LAUNCH EDITION",
    "SPIDER"
   ],
   "kasa": [
    "COUPE",
    "SPIDER"
   ],
   "motor": [
    "1.75 TBI TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 ILERI TCT ÇIFT KAVRAMA"
   ]
  },
  "4C SPIDER": {
   "yil": 2015,
   "paket": [
    "SPIDER",
    "LAUNCH EDITION"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "1.75 TBI TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 ILERI TCT ÇIFT KAVRAMA"
   ]
  },
  "GIULIA": {
   "yil": 2016,
   "paket": [
    "GIULIA",
    "SUPER",
    "BUSINESS",
    "LUSSO",
    "VELOCE",
    "TI",
    "QUADRIFOGLIO"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 TURBO",
    "2.2 TURBO DIZEL",
    "2.9 V6 BI-TURBO"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI ZF OTOMATIK",
    "MANUEL"
   ]
  },
  "STELVIO": {
   "yil": 2017,
   "paket": [
    "STELVIO",
    "SUPER",
    "BUSINESS",
    "LUSSO",
    "VELOCE",
    "TI",
    "QUADRIFOGLIO"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TURBO",
    "2.2 TURBO DIZEL",
    "2.9 V6 BI-TURBO"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI ZF OTOMATIK"
   ]
  },
  "TONALE": {
   "yil": 2022,
   "paket": [
    "SUPER",
    "SPRINT",
    "TI",
    "VELOCE",
    "SPECIALE"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 HYBRID",
    "1.6 DIESEL",
    "1.3 PLUG-IN HYBRID Q4"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "7 ILERI TCT",
    "6 ILERI TCT",
    "EDCT6",
    "OTOMATIK"
   ]
  },
  "JUNIOR": {
   "yil": 2024,
   "paket": [
    "BASE",
    "SPECIALE",
    "IBRIDA",
    "ELETTRICA",
    "IBRIDA SPECIALE+",
    "ELETTRICA SPECIALE+"
   ],
   "kasa": [
    "B-SUV"
   ],
   "motor": [
    "1.2 HYBRID 145",
    "ELEKTRIK 115 KW"
   ],
   "yakit": [
    "HIBRIT",
    "ELEKTRIK"
   ],
   "sanziman": [
    "EDCT6",
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "AUDI": {
  "A1": {
   "yil": 2010,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "HATCHBACK",
    "SPORTBACK"
   ],
   "motor": [
    "1.2 TFSI",
    "1.4 TFSI",
    "1.0 TFSI",
    "1.5 TFSI",
    "1.6 TDI",
    "2.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC"
   ]
  },
  "A2": {
   "yil": 2000,
   "paket": [
    "ATTRACTION",
    "ADVANCE",
    "COLOUR STORM"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.4",
    "1.6 FSI",
    "1.2 TDI",
    "1.4 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC"
   ]
  },
  "A3 SPORTBACK": {
   "yil": 2004,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "HATCHBACK",
    "SPORTBACK"
   ],
   "motor": [
    "1.2 TFSI",
    "1.4 TFSI",
    "1.5 TFSI",
    "1.6 TDI",
    "2.0 TDI",
    "2.0 TFSI",
    "1.4 TFSI E-TRON"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC"
   ]
  },
  "A3 SEDAN": {
   "yil": 2013,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.0 TFSI",
    "1.4 TFSI",
    "1.5 TFSI",
    "1.6 TDI",
    "2.0 TDI",
    "2.0 TFSI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC"
   ]
  },
  "A3 CABRIOLET": {
   "yil": 2008,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "S LINE"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "1.4 TFSI",
    "1.8 TFSI",
    "2.0 TFSI",
    "1.6 TDI",
    "2.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC"
   ]
  },
  "A4": {
   "yil": 2000,
   "paket": [
    "BASE",
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.6",
    "1.8 TFSI",
    "2.0 TFSI",
    "2.4",
    "2.8",
    "3.0 TFSI",
    "1.9 TDI",
    "2.0 TDI",
    "2.5 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC",
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "A4 AVANT": {
   "yil": 2000,
   "paket": [
    "BASE",
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "AVANT",
    "STATION WAGON"
   ],
   "motor": [
    "1.6",
    "1.8 TFSI",
    "2.0 TFSI",
    "2.4",
    "2.8",
    "3.0 TFSI",
    "1.9 TDI",
    "2.0 TDI",
    "2.5 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC",
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "A4 ALLROAD QUATTRO": {
   "yil": 2009,
   "paket": [
    "ALLROAD",
    "S LINE"
   ],
   "kasa": [
    "ALLROAD"
   ],
   "motor": [
    "2.0 TFSI",
    "2.0 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "S TRONIC",
    "TIPTRONIC"
   ]
  },
  "A5 COUPE": {
   "yil": 2007,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "1.8 TFSI",
    "2.0 TFSI",
    "3.2 FSI",
    "2.0 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC",
    "S TRONIC",
    "TIPTRONIC"
   ]
  },
  "A5 SPORTBACK": {
   "yil": 2009,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SPORTBACK"
   ],
   "motor": [
    "1.8 TFSI",
    "2.0 TFSI",
    "3.0 TFSI",
    "2.0 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC",
    "S TRONIC",
    "TIPTRONIC"
   ]
  },
  "A5 CABRIOLET": {
   "yil": 2009,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "1.8 TFSI",
    "2.0 TFSI",
    "3.0 TFSI",
    "2.0 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC",
    "S TRONIC",
    "TIPTRONIC"
   ]
  },
  "A6": {
   "yil": 2000,
   "paket": [
    "BASE",
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.8 TFSI",
    "2.0 TFSI",
    "2.4",
    "2.8 FSI",
    "3.0 TFSI",
    "4.2 FSI",
    "1.9 TDI",
    "2.0 TDI",
    "2.7 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC",
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "A6 AVANT": {
   "yil": 2000,
   "paket": [
    "BASE",
    "ATTRACTION",
    "AMBITION",
    "AMBIENTE",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "AVANT"
   ],
   "motor": [
    "1.8 TFSI",
    "2.0 TFSI",
    "2.8 FSI",
    "3.0 TFSI",
    "4.2 FSI",
    "1.9 TDI",
    "2.0 TDI",
    "2.7 TDI",
    "3.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "MULTITRONIC",
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "A6 ALLROAD QUATTRO": {
   "yil": 2000,
   "paket": [
    "ALLROAD",
    "S LINE"
   ],
   "kasa": [
    "ALLROAD"
   ],
   "motor": [
    "2.5 TDI",
    "2.7 TDI",
    "3.0 TDI",
    "3.0 TFSI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "A7 SPORTBACK": {
   "yil": 2010,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "DESIGN",
    "SPORT",
    "S LINE"
   ],
   "kasa": [
    "SPORTBACK"
   ],
   "motor": [
    "2.0 TFSI",
    "3.0 TFSI",
    "2.8 FSI",
    "3.0 TDI",
    "4.0 TFSI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "S TRONIC",
    "TIPTRONIC"
   ]
  },
  "A8": {
   "yil": 2000,
   "paket": [
    "BASE",
    "ATTRACTION",
    "AMBITION",
    "DESIGN",
    "SPORT",
    "S LINE",
    "L"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.8 FSI",
    "3.0 TDI",
    "3.0 TFSI",
    "4.0 TFSI",
    "4.2 FSI",
    "6.0 W12"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "TIPTRONIC",
    "MULTITRONIC",
    "S TRONIC"
   ]
  },
  "TT COUPE": {
   "yil": 2000,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "S LINE",
    "S"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "1.8T",
    "2.0 TFSI",
    "2.0 TDI",
    "3.2 VR6"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC",
    "DSG"
   ]
  },
  "TT ROADSTER": {
   "yil": 2000,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "S LINE",
    "S"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "1.8T",
    "2.0 TFSI",
    "2.0 TDI",
    "3.2 VR6"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC",
    "DSG"
   ]
  },
  "R8 COUPE": {
   "yil": 2007,
   "paket": [
    "R8",
    "V8",
    "V10",
    "PERFORMANCE"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "4.2 FSI V8",
    "5.2 FSI V10"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "R TRONIC",
    "S TRONIC"
   ]
  },
  "R8 SPYDER": {
   "yil": 2010,
   "paket": [
    "V8",
    "V10",
    "PERFORMANCE"
   ],
   "kasa": [
    "SPYDER"
   ],
   "motor": [
    "4.2 FSI V8",
    "5.2 FSI V10"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "R TRONIC",
    "S TRONIC"
   ]
  },
  "Q2": {
   "yil": 2016,
   "paket": [
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.0 TFSI",
    "1.4 TFSI",
    "1.5 TFSI",
    "1.6 TDI",
    "2.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC"
   ]
  },
  "Q3": {
   "yil": 2011,
   "paket": [
    "ATTRACTION",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.4 TFSI",
    "2.0 TFSI",
    "2.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC"
   ]
  },
  "Q3 SPORTBACK": {
   "yil": 2019,
   "paket": [
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SUV COUPE",
    "SPORTBACK"
   ],
   "motor": [
    "1.5 TFSI",
    "2.0 TFSI",
    "2.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "S TRONIC"
   ]
  },
  "Q4 E-TRON": {
   "yil": 2021,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV",
    "ELEKTRIKLI"
   ],
   "motor": [
    "35 E-TRON",
    "40 E-TRON",
    "45 E-TRON",
    "50 E-TRON QUATTRO"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "Q4 SPORTBACK E-TRON": {
   "yil": 2021,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV COUPE",
    "ELEKTRIKLI"
   ],
   "motor": [
    "35 E-TRON",
    "40 E-TRON",
    "45 E-TRON",
    "50 E-TRON QUATTRO"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "Q5": {
   "yil": 2008,
   "paket": [
    "ATTRACTION",
    "AMBITION",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TFSI",
    "3.0 TFSI",
    "2.0 TDI",
    "3.0 TDI",
    "2.0 TFSI E"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "S TRONIC",
    "TIPTRONIC"
   ]
  },
  "Q5 SPORTBACK": {
   "yil": 2020,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV COUPE",
    "SPORTBACK"
   ],
   "motor": [
    "2.0 TFSI",
    "2.0 TDI",
    "2.0 TFSI E"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "S TRONIC"
   ]
  },
  "Q6 E-TRON": {
   "yil": 2024,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV",
    "ELEKTRIKLI"
   ],
   "motor": [
    "E-TRON",
    "QUATTRO"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "Q6 SPORTBACK E-TRON": {
   "yil": 2024,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV COUPE",
    "ELEKTRIKLI"
   ],
   "motor": [
    "E-TRON",
    "QUATTRO"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "Q7": {
   "yil": 2006,
   "paket": [
    "ATTRACTION",
    "DESIGN",
    "SPORT",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "3.0 TDI",
    "4.2 TDI",
    "3.0 TFSI",
    "4.2 FSI",
    "6.0 TDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "TIPTRONIC"
   ]
  },
  "Q8": {
   "yil": 2018,
   "paket": [
    "DESIGN",
    "S LINE",
    "ADVANCED"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "55 TFSI",
    "45 TDI",
    "50 TDI",
    "60 TFSI E"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "TIPTRONIC"
   ]
  },
  "Q8 E-TRON": {
   "yil": 2018,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV",
    "ELEKTRIKLI"
   ],
   "motor": [
    "50 E-TRON",
    "55 E-TRON",
    "S E-TRON"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "Q8 SPORTBACK E-TRON": {
   "yil": 2020,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV COUPE",
    "ELEKTRIKLI"
   ],
   "motor": [
    "50 E-TRON",
    "55 E-TRON",
    "S E-TRON"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-TRON": {
   "yil": 2019,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV",
    "ELEKTRIKLI"
   ],
   "motor": [
    "50 QUATTRO",
    "55 QUATTRO",
    "S QUATTRO"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-TRON SPORTBACK": {
   "yil": 2020,
   "paket": [
    "ADVANCED",
    "S LINE"
   ],
   "kasa": [
    "SUV COUPE",
    "ELEKTRIKLI"
   ],
   "motor": [
    "50 QUATTRO",
    "55 QUATTRO",
    "S QUATTRO"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-TRON GT": {
   "yil": 2021,
   "paket": [
    "E-TRON GT",
    "S E-TRON GT",
    "RS E-TRON GT"
   ],
   "kasa": [
    "GRAN TURISMO",
    "ELEKTRIKLI"
   ],
   "motor": [
    "E-TRON GT",
    "S E-TRON GT",
    "RS E-TRON GT",
    "RS E-TRON GT PERFORMANCE"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "2 ILERI OTOMATIK"
   ]
  },
  "S3": {
   "yil": 2000,
   "paket": [
    "S3",
    "S LINE"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN"
   ],
   "motor": [
    "1.8T",
    "2.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "S TRONIC"
   ]
  },
  "S4": {
   "yil": 2000,
   "paket": [
    "S4",
    "S LINE"
   ],
   "kasa": [
    "SEDAN",
    "AVANT"
   ],
   "motor": [
    "2.7 BITURBO",
    "3.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "S5": {
   "yil": 2007,
   "paket": [
    "S5",
    "S LINE"
   ],
   "kasa": [
    "COUPE",
    "SPORTBACK",
    "CABRIO"
   ],
   "motor": [
    "4.2 FSI",
    "3.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "S6": {
   "yil": 2000,
   "paket": [
    "S6",
    "S LINE"
   ],
   "kasa": [
    "SEDAN",
    "AVANT"
   ],
   "motor": [
    "4.2 V8",
    "5.2 V10",
    "4.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "S7": {
   "yil": 2012,
   "paket": [
    "S7",
    "S LINE"
   ],
   "kasa": [
    "SPORTBACK"
   ],
   "motor": [
    "4.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "S TRONIC"
   ]
  },
  "S8": {
   "yil": 2000,
   "paket": [
    "S8"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "4.2 V8",
    "5.2 V10",
    "4.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "RS3": {
   "yil": 2011,
   "paket": [
    "RS 3",
    "RS 3 PERFORMANCE"
   ],
   "kasa": [
    "SPORTBACK",
    "SEDAN"
   ],
   "motor": [
    "2.5 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "S TRONIC"
   ]
  },
  "RS4": {
   "yil": 2000,
   "paket": [
    "RS4"
   ],
   "kasa": [
    "SEDAN",
    "AVANT"
   ],
   "motor": [
    "2.7 BITURBO",
    "4.2 FSI",
    "2.9 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "RS5": {
   "yil": 2010,
   "paket": [
    "RS5"
   ],
   "kasa": [
    "COUPE",
    "SPORTBACK",
    "CABRIO"
   ],
   "motor": [
    "4.2 FSI",
    "2.9 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "RS6": {
   "yil": 2002,
   "paket": [
    "RS6"
   ],
   "kasa": [
    "SEDAN",
    "AVANT"
   ],
   "motor": [
    "4.2 BITURBO",
    "5.0 TFSI",
    "4.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "RS7": {
   "yil": 2013,
   "paket": [
    "RS7",
    "PERFORMANCE"
   ],
   "kasa": [
    "SPORTBACK"
   ],
   "motor": [
    "4.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "TIPTRONIC",
    "S TRONIC"
   ]
  },
  "RS Q3": {
   "yil": 2013,
   "paket": [
    "RS Q3",
    "PERFORMANCE"
   ],
   "kasa": [
    "SUV",
    "SPORTBACK"
   ],
   "motor": [
    "2.5 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "S TRONIC"
   ]
  },
  "RS Q5": {
   "yil": 2026,
   "paket": [
    "RS Q5"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.9 TFSI",
    "HIBRIT"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "RS Q8": {
   "yil": 2019,
   "paket": [
    "RS Q8",
    "PERFORMANCE"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "4.0 TFSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "TIPTRONIC"
   ]
  }
 },
 "BMW": {
  "1 SERISI": {
   "yil": 2004,
   "paket": [
    "116I",
    "118I",
    "120I",
    "125I",
    "116D",
    "118D",
    "120D",
    "M135I",
    "120"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.6",
    "2.0",
    "1.5",
    "2.0 TWINPOWER TURBO"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "MILD HYBRID"
   ],
   "sanziman": [
    "MANUEL",
    "6 ILERI OTOMATIK",
    "7 ILERI STEPTRONIC",
    "8 ILERI STEPTRONIC"
   ]
  },
  "2 SERISI ACTIVE TOURER": {
   "yil": 2014,
   "paket": [
    "ADVANTAGE",
    "LUXURY LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "MPV",
    "ACTIVE TOURER"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.0 DIZEL",
    "1.5 PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "6 ILERI STEPTRONIC",
    "8 ILERI STEPTRONIC"
   ]
  },
  "2 SERISI GRAN COUPE": {
   "yil": 2019,
   "paket": [
    "ADVANTAGE",
    "LUXURY LINE",
    "M SPORT"
   ],
   "kasa": [
    "GRAN COUPE"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO",
    "1.5 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "7 ILERI STEPTRONIC",
    "8 ILERI STEPTRONIC"
   ]
  },
  "2 SERISI COUPE": {
   "yil": 2014,
   "paket": [
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO",
    "3.0 TURBO",
    "2.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "8 ILERI STEPTRONIC"
   ]
  },
  "3 SERISI SEDAN": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "DYNAMIC",
    "LUXURY LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.6",
    "2.0",
    "2.5",
    "3.0",
    "1.5 TURBO",
    "2.0 TURBO",
    "1.6 DIZEL",
    "2.0 DIZEL",
    "3.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT",
    "MILD HYBRID"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "3 SERISI TOURING": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "LUXURY LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "STATION WAGON"
   ],
   "motor": [
    "1.6",
    "2.0",
    "3.0",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIZEL",
    "3.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "3 SERISI COUPE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "1.8",
    "2.0",
    "2.5",
    "3.0",
    "3.0 TURBO",
    "2.0 DIZEL",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "DCT"
   ]
  },
  "3 SERISI CABRIO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "2.0",
    "2.5",
    "3.0",
    "3.0 TURBO",
    "2.0 DIZEL",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC"
   ]
  },
  "4 SERISI COUPE": {
   "yil": 2013,
   "paket": [
    "LUXURY LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 TURBO",
    "3.0 DIZEL",
    "2.0 PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "4 SERISI GRAN COUPE": {
   "yil": 2014,
   "paket": [
    "LUXURY LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "GRAN COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 TURBO",
    "2.0 DIZEL",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "4 SERISI CABRIO": {
   "yil": 2014,
   "paket": [
    "LUXURY LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 TURBO",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "5 SERISI SEDAN": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "LUXURY LINE",
    "MODERN LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0",
    "2.5",
    "3.0",
    "4.4 V8",
    "2.0 TURBO",
    "2.0 DIZEL",
    "3.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT",
    "MILD HYBRID"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "5 SERISI TOURING": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "LUXURY LINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "STATION WAGON"
   ],
   "motor": [
    "2.0",
    "2.5",
    "3.0",
    "4.4 V8",
    "2.0 DIZEL",
    "3.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "6 SERISI COUPE": {
   "yil": 2004,
   "paket": [
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "3.0",
    "4.4 V8",
    "5.0 V10",
    "3.0 DIZEL",
    "4.4 TURBO"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "DCT"
   ]
  },
  "6 SERISI GRAN COUPE": {
   "yil": 2012,
   "paket": [
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "GRAN COUPE"
   ],
   "motor": [
    "3.0 TURBO",
    "4.4 V8",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "6 SERISI CABRIO": {
   "yil": 2004,
   "paket": [
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "3.0",
    "4.4 V8",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "STEPTRONIC"
   ]
  },
  "7 SERISI": {
   "yil": 2000,
   "paket": [
    "BASE",
    "EXCELLENCE",
    "M SPORT",
    "PURE EXCELLENCE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "3.0",
    "4.4 V8",
    "6.0 V12",
    "2.0 TURBO",
    "3.0 DIZEL",
    "4.4 TURBO",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "8 SERISI COUPE": {
   "yil": 2018,
   "paket": [
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "3.0 TURBO",
    "4.4 V8",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "8 SERISI GRAN COUPE": {
   "yil": 2019,
   "paket": [
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "GRAN COUPE"
   ],
   "motor": [
    "3.0 TURBO",
    "4.4 V8",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "8 SERISI CABRIO": {
   "yil": 2019,
   "paket": [
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "3.0 TURBO",
    "4.4 V8",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "X1": {
   "yil": 2009,
   "paket": [
    "BASE",
    "XLINE",
    "SPORT LINE",
    "M SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO",
    "1.8 DIZEL",
    "2.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT",
    "MILD HYBRID"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "7 ILERI ÇIFT KAVRAMA"
   ]
  },
  "X2": {
   "yil": 2018,
   "paket": [
    "XLINE",
    "M SPORT"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "7 ILERI STEPTRONIC",
    "8 ILERI STEPTRONIC"
   ]
  },
  "X3": {
   "yil": 2004,
   "paket": [
    "BASE",
    "XLINE",
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0",
    "2.5",
    "3.0",
    "2.0 TURBO",
    "3.0 TURBO",
    "2.0 DIZEL",
    "3.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT",
    "MILD HYBRID"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "X4": {
   "yil": 2014,
   "paket": [
    "XLINE",
    "M SPORT"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 TURBO",
    "2.0 DIZEL",
    "3.0 DIZEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "X5": {
   "yil": 2000,
   "paket": [
    "BASE",
    "XLINE",
    "LUXURY",
    "M SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "3.0",
    "4.4 V8",
    "4.8 V8",
    "4.4 TURBO",
    "3.0 DIZEL",
    "4.0 DIZEL",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "X6": {
   "yil": 2008,
   "paket": [
    "XLINE",
    "M SPORT"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "3.0",
    "4.4 V8",
    "3.0 DIZEL",
    "4.4 TURBO"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "STEPTRONIC",
    "8 ILERI OTOMATIK"
   ]
  },
  "X7": {
   "yil": 2019,
   "paket": [
    "XLINE",
    "M SPORT",
    "EXCELLENCE"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "3.0 TURBO",
    "3.0 DIZEL",
    "4.4 V8"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "8 ILERI STEPTRONIC"
   ]
  },
  "Z4": {
   "yil": 2003,
   "paket": [
    "ROADSTER",
    "SPORT",
    "M SPORT"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0",
    "2.5",
    "3.0",
    "3.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "STEPTRONIC"
   ]
  },
  "I3": {
   "yil": 2013,
   "paket": [
    "BASE",
    "RANGE EXTENDER",
    "S"
   ],
   "kasa": [
    "HATCHBACK",
    "ELEKTRIKLI"
   ],
   "motor": [
    "ELEKTRIK",
    "RANGE EXTENDER"
   ],
   "yakit": [
    "ELEKTRIK",
    "HIBRIT DESTEKLI"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "I4": {
   "yil": 2021,
   "paket": [
    "EDRIVE35",
    "EDRIVE40",
    "M50"
   ],
   "kasa": [
    "GRAN COUPE",
    "ELEKTRIKLI"
   ],
   "motor": [
    "EDRIVE35",
    "EDRIVE40",
    "M50"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK",
    "2 ILERI"
   ]
  },
  "I5": {
   "yil": 2023,
   "paket": [
    "EDRIVE40",
    "M60 XDRIVE"
   ],
   "kasa": [
    "SEDAN",
    "TOURING",
    "ELEKTRIKLI"
   ],
   "motor": [
    "EDRIVE40",
    "M60 XDRIVE"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK",
    "2 ILERI"
   ]
  },
  "I7": {
   "yil": 2022,
   "paket": [
    "XDRIVE60",
    "M70 XDRIVE"
   ],
   "kasa": [
    "SEDAN",
    "ELEKTRIKLI"
   ],
   "motor": [
    "XDRIVE60",
    "M70 XDRIVE"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK",
    "2 ILERI"
   ]
  },
  "IX1": {
   "yil": 2022,
   "paket": [
    "EDRIVE20",
    "XDRIVE30"
   ],
   "kasa": [
    "SUV",
    "ELEKTRIKLI"
   ],
   "motor": [
    "EDRIVE20",
    "XDRIVE30"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "IX2": {
   "yil": 2023,
   "paket": [
    "EDRIVE20",
    "XDRIVE30"
   ],
   "kasa": [
    "SUV COUPE",
    "ELEKTRIKLI"
   ],
   "motor": [
    "EDRIVE20",
    "XDRIVE30"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "IX3": {
   "yil": 2021,
   "paket": [
    "INSPIRING",
    "IMPRESSIVE",
    "M SPORT"
   ],
   "kasa": [
    "SUV",
    "ELEKTRIKLI"
   ],
   "motor": [
    "EDRIVE80",
    "ELEKTRIKLI"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "IX": {
   "yil": 2021,
   "paket": [
    "XDRIVE40",
    "XDRIVE50",
    "M60",
    "XDRIVE60"
   ],
   "kasa": [
    "SUV",
    "ELEKTRIKLI"
   ],
   "motor": [
    "XDRIVE40",
    "XDRIVE50",
    "M60",
    "XDRIVE60"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK",
    "2 ILERI"
   ]
  },
  "M2": {
   "yil": 2016,
   "paket": [
    "M2",
    "COMPETITION",
    "CS"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "3.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "8 ILERI M STEPTRONIC"
   ]
  },
  "M3": {
   "yil": 2000,
   "paket": [
    "M3",
    "COMPETITION",
    "CS"
   ],
   "kasa": [
    "SEDAN",
    "COUPE",
    "TOURING"
   ],
   "motor": [
    "3.2 I6",
    "4.0 V8",
    "3.0 TWINPOWER TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "DCT",
    "8 ILERI M STEPTRONIC"
   ]
  },
  "M4": {
   "yil": 2014,
   "paket": [
    "M4",
    "COMPETITION",
    "CS"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "3.0 TWINPOWER TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "DCT",
    "8 ILERI M STEPTRONIC"
   ]
  },
  "M5": {
   "yil": 2000,
   "paket": [
    "M5",
    "COMPETITION",
    "CS"
   ],
   "kasa": [
    "SEDAN",
    "TOURING"
   ],
   "motor": [
    "4.9 V8",
    "5.0 V10",
    "4.4 TWINPOWER TURBO",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "SMG",
    "DCT",
    "8 ILERI M STEPTRONIC"
   ]
  },
  "M6": {
   "yil": 2005,
   "paket": [
    "M6",
    "COMPETITION"
   ],
   "kasa": [
    "COUPE",
    "CABRIO",
    "GRAN COUPE"
   ],
   "motor": [
    "5.0 V10",
    "4.4 TWINPOWER TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "SMG",
    "DCT",
    "7 ILERI"
   ]
  },
  "X3 M": {
   "yil": 2019,
   "paket": [
    "X3 M",
    "COMPETITION"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "3.0 TWINPOWER TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "8 ILERI M STEPTRONIC"
   ]
  },
  "X4 M": {
   "yil": 2019,
   "paket": [
    "X4 M",
    "COMPETITION"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "3.0 TWINPOWER TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "8 ILERI M STEPTRONIC"
   ]
  },
  "X5 M": {
   "yil": 2000,
   "paket": [
    "X5 M",
    "COMPETITION"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "4.4 TWINPOWER TURBO",
    "4.4 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "8 ILERI M STEPTRONIC"
   ]
  },
  "X6 M": {
   "yil": 2009,
   "paket": [
    "X6 M",
    "COMPETITION"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "4.4 TWINPOWER TURBO",
    "4.4 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "8 ILERI M STEPTRONIC"
   ]
  },
  "XM": {
   "yil": 2022,
   "paket": [
    "XM",
    "LABEL"
   ],
   "kasa": [
    "SUV",
    "PLUG-IN HYBRID"
   ],
   "motor": [
    "4.4 V8 TWINPOWER TURBO + ELEKTRIK"
   ],
   "yakit": [
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "8 ILERI M STEPTRONIC"
   ]
  }
 },
 "BYD": {
  "F0": {
   "yil": 2008,
   "paket": [
    "GL-I",
    "GLX-I"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.0"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "F3": {
   "yil": 2003,
   "paket": [
    "GL-I",
    "GLX-I",
    "DELUXE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.5",
    "1.6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "DCT"
   ]
  },
  "F6": {
   "yil": 2008,
   "paket": [
    "COMFORT",
    "LUXURY",
    "PREMIUM"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0",
    "2.4"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "S6": {
   "yil": 2010,
   "paket": [
    "COMFORT",
    "LUXURY",
    "PREMIUM"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0",
    "2.4"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "S7": {
   "yil": 2014,
   "paket": [
    "COMFORT",
    "LUXURY",
    "PREMIUM"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "DCT"
   ]
  },
  "QIN": {
   "yil": 2013,
   "paket": [
    "HYBRID",
    "DM-I"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.5 HYBRID",
    "1.5 DM-I"
   ],
   "yakit": [
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "DCT",
    "E-CVT"
   ]
  },
  "SONG": {
   "yil": 2015,
   "paket": [
    "CLASSIC",
    "PRO",
    "PLUS",
    "DM-I"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO",
    "1.5 DM-I"
   ],
   "yakit": [
    "BENZIN",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "DCT",
    "E-CVT"
   ]
  },
  "YUAN": {
   "yil": 2016,
   "paket": [
    "BASE",
    "PREMIUM",
    "PLUS"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK",
    "1.5"
   ],
   "yakit": [
    "ELEKTRIK",
    "BENZIN"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK",
    "MANUEL"
   ]
  },
  "E2": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "LUXURY",
    "HONOR"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E3": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "HAN": {
   "yil": 2020,
   "paket": [
    "EXECUTIVE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK",
    "DM-I"
   ],
   "yakit": [
    "ELEKTRIK",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK",
    "E-CVT"
   ]
  },
  "TANG": {
   "yil": 2015,
   "paket": [
    "FLAGSHIP"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "ELEKTRIK",
    "DM-I"
   ],
   "yakit": [
    "ELEKTRIK",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK",
    "E-CVT"
   ]
  },
  "DOLPHIN": {
   "yil": 2021,
   "paket": [
    "COMFORT",
    "DESIGN"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ATTO 3": {
   "yil": 2022,
   "paket": [
    "COMFORT",
    "DESIGN"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "SEAL": {
   "yil": 2022,
   "paket": [
    "DESIGN",
    "EXCELLENCE",
    "AWD EXCELLENCE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "SEAL U EV": {
   "yil": 2023,
   "paket": [
    "DESIGN"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "SEAL U DM-I": {
   "yil": 2023,
   "paket": [
    "DESIGN"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5L DM-I",
    "1.5T AWD DM-I"
   ],
   "yakit": [
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "E-CVT"
   ]
  },
  "SEALION 7": {
   "yil": 2025,
   "paket": [
    "DESIGN",
    "EXCELLENCE"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ATTO 2": {
   "yil": 2025,
   "paket": [
    "BOOST",
    "COMFORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "T5": {
   "yil": 2025,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "PANELVAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "T5DM": {
   "yil": 2025,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "PANELVAN"
   ],
   "motor": [
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "CHERY": {
  "TIGGO 3": {
   "yil": 2000,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "CVT"
   ]
  },
  "TIGGO 5": {
   "yil": 2013,
   "paket": [
    "COMFORT",
    "LUXURY",
    "EXCELLENT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "TIGGO 7": {
   "yil": 2016,
   "paket": [
    "COMFORT",
    "LUXURY",
    "PRO",
    "PRESTIGE"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO",
    "1.6 TGDI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "DCT",
    "7 İLERI DCT"
   ]
  },
  "TIGGO 7 PRO": {
   "yil": 2020,
   "paket": [
    "LUXURY",
    "EXCELLENT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "7 İLERI DCT"
   ]
  },
  "TIGGO 7 PRO MAX": {
   "yil": 2023,
   "paket": [
    "INTELLIGENT",
    "EXCEPTIONAL"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.6 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "7 İLERI DCT"
   ]
  },
  "TIGGO 8": {
   "yil": 2018,
   "paket": [
    "COMFORT",
    "LUXURY",
    "EXCELLENT",
    "PRESTIGE"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO",
    "1.6 TGDI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "DCT",
    "7 İLERI DCT"
   ]
  },
  "TIGGO 8 PRO": {
   "yil": 2021,
   "paket": [
    "LUXURY",
    "EXCELLENT"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.6 TGDI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "7 İLERI DCT"
   ]
  },
  "TIGGO 8 PRO MAX": {
   "yil": 2023,
   "paket": [
    "INTELLIGENT",
    "EXCEPTIONAL"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.6 TGDI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "7 İLERI DCT"
   ]
  },
  "TIGGO 4": {
   "yil": 2025,
   "paket": [
    "COMFORT",
    "LUXURY",
    "EXCELLENT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "OMODA 5": {
   "yil": 2022,
   "paket": [
    "COMFORT",
    "LUXURY",
    "EXCELLENT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "OMODA 5 PRO": {
   "yil": 2024,
   "paket": [
    "VISION",
    "INTELLIGENT",
    "EXCEPTIONAL"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.6 TGDI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "7 İLERI DCT"
   ]
  }
 },
 "CHEVROLET": {
  "SPARK": {
   "yil": 2000,
   "paket": [
    "BASE",
    "LS",
    "LT"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "0.8",
    "1.0",
    "1.2"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "MATIZ": {
   "yil": 2000,
   "paket": [
    "S",
    "SE",
    "SX"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "0.8",
    "1.0"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "AVEO": {
   "yil": 2002,
   "paket": [
    "BASE",
    "LS",
    "LT",
    "LTZ"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.4",
    "1.6"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "KALOS": {
   "yil": 2002,
   "paket": [
    "SE",
    "SX"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.4",
    "1.6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "LACETTI": {
   "yil": 2004,
   "paket": [
    "SE",
    "SX",
    "PLATINUM"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.4",
    "1.6",
    "1.8",
    "2.0"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CRUZE": {
   "yil": 2008,
   "paket": [
    "LS",
    "LT",
    "LTZ"
   ],
   "kasa": [
    "SEDAN",
    "HATCHBACK",
    "STATION WAGON"
   ],
   "motor": [
    "1.4 TURBO",
    "1.6",
    "1.8",
    "2.0 DIESEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CAPTIVA": {
   "yil": 2006,
   "paket": [
    "LS",
    "LT",
    "LTZ"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 DIESEL",
    "2.4",
    "3.0 V6"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "EPICA": {
   "yil": 2006,
   "paket": [
    "LS",
    "LT",
    "LTZ"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 DIESEL",
    "2.5",
    "2.0"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "ORLANDO": {
   "yil": 2011,
   "paket": [
    "LS",
    "LT",
    "LTZ"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "1.8",
    "2.0 DIESEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "TRAX": {
   "yil": 2013,
   "paket": [
    "LS",
    "LT",
    "LTZ"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.4 TURBO",
    "1.6",
    "1.7 DIESEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "MALIBU": {
   "yil": 2012,
   "paket": [
    "LS",
    "LT",
    "LTZ"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 TURBO DIESEL",
    "2.5"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CAMARO": {
   "yil": 2000,
   "paket": [
    "LS",
    "LT",
    "SS",
    "ZL1"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "3.6 V6",
    "6.2 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CORVETTE": {
   "yil": 2000,
   "paket": [
    "COUPE",
    "CONVERTIBLE",
    "GRAND SPORT",
    "Z06"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "5.7 V8",
    "6.0 V8",
    "6.2 V8",
    "6.2 SUPERCHARGED"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "TAHOE": {
   "yil": 2000,
   "paket": [
    "LS",
    "LT",
    "LTZ",
    "HIGH COUNTRY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "4.8 V8",
    "5.3 V8",
    "6.2 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "SUBURBAN": {
   "yil": 2000,
   "paket": [
    "LS",
    "LT",
    "LTZ",
    "HIGH COUNTRY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "5.3 V8",
    "6.0 V8",
    "6.2 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "SILVERADO": {
   "yil": 2000,
   "paket": [
    "WT",
    "LT",
    "LTZ",
    "HIGH COUNTRY"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "4.3 V6",
    "5.3 V8",
    "6.2 V8",
    "6.6 DIESEL"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "CITROEN": {
  "SAXO": {
   "yil": 2000,
   "paket": [
    "X",
    "SX",
    "VTS"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.1",
    "1.4",
    "1.6"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "C1": {
   "yil": 2005,
   "paket": [
    "LIVE",
    "FEEL",
    "SHINE"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.0",
    "1.2",
    "1.4 HDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "C2": {
   "yil": 2003,
   "paket": [
    "SX",
    "VTR",
    "VTS"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.1",
    "1.4",
    "1.6",
    "1.6 HDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "C3": {
   "yil": 2002,
   "paket": [
    "X",
    "SX",
    "FEEL",
    "SHINE"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.1",
    "1.2 PURETECH",
    "1.4",
    "1.6 HDI",
    "1.5 BLUEHDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EAT6",
    "EAT8"
   ]
  },
  "C3 AIRCROSS": {
   "yil": 2017,
   "paket": [
    "FEEL",
    "SHINE",
    "MAX"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2 PURETECH",
    "1.5 BLUEHDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EAT6"
   ]
  },
  "C4": {
   "yil": 2004,
   "paket": [
    "X",
    "SX",
    "COMFORT",
    "FEEL",
    "SHINE"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2 PURETECH",
    "1.4",
    "1.6",
    "1.6 HDI",
    "1.5 BLUEHDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "ELEKTRIK"
   ],
   "sanziman": [
    "MANUEL",
    "EAT6",
    "EAT8"
   ]
  },
  "C4 X": {
   "yil": 2022,
   "paket": [
    "FEEL",
    "SHINE",
    "MAX"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2 PURETECH",
    "1.5 BLUEHDI",
    "100 KW ELECTRIC"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "ELEKTRIK"
   ],
   "sanziman": [
    "MANUEL",
    "EAT8",
    "TEK ORANLI OTOMATIK"
   ]
  },
  "C5": {
   "yil": 2001,
   "paket": [
    "X",
    "SX",
    "EXCLUSIVE"
   ],
   "kasa": [
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.8",
    "2.0",
    "3.0 V6",
    "1.6 HDI",
    "2.0 HDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "C5 AIRCROSS": {
   "yil": 2018,
   "paket": [
    "FEEL",
    "SHINE",
    "MAX"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2 PURETECH",
    "1.5 BLUEHDI",
    "1.6 HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "EAT8"
   ]
  },
  "C-ELYSEE": {
   "yil": 2012,
   "paket": [
    "ATTRACTION",
    "FEEL",
    "SHINE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2 PURETECH",
    "1.6 VTI",
    "1.6 HDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EAT6"
   ]
  },
  "DS3": {
   "yil": 2010,
   "paket": [
    "CHIC",
    "SO CHIC",
    "SPORT CHIC"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2 PURETECH",
    "1.6 VTI",
    "1.6 THP",
    "1.6 HDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EAT6"
   ]
  },
  "DS4": {
   "yil": 2011,
   "paket": [
    "CHIC",
    "SO CHIC",
    "SPORT CHIC"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2 PURETECH",
    "1.6 THP",
    "2.0 HDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EAT6"
   ]
  },
  "DS5": {
   "yil": 2011,
   "paket": [
    "CHIC",
    "SO CHIC",
    "SPORT CHIC"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.6 THP",
    "2.0 HDI",
    "HYBRID4"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "EAT6"
   ]
  },
  "BERLINGO": {
   "yil": 2000,
   "paket": [
    "X",
    "SX",
    "FEEL",
    "SHINE"
   ],
   "kasa": [
    "PANELVAN",
    "MPV"
   ],
   "motor": [
    "1.4",
    "1.6 HDI",
    "1.5 BLUEHDI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EAT8"
   ]
  },
  "JUMPY": {
   "yil": 2000,
   "paket": [
    "COMBI",
    "CLUB",
    "BUSINESS"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "1.6 HDI",
    "2.0 HDI",
    "2.0 BLUEHDI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EAT8"
   ]
  },
  "JUMPER": {
   "yil": 2000,
   "paket": [
    "VAN",
    "COMBI",
    "MAXI"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "2.2 HDI",
    "2.8 HDI",
    "2.0 BLUEHDI",
    "2.2 BLUEHDI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "AMI": {
   "yil": 2020,
   "paket": [
    "AMI",
    "POP",
    "TONIC"
   ],
   "kasa": [
    "MICROCAR"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-C3": {
   "yil": 2024,
   "paket": [
    "YOU",
    "PLUS",
    "MAX"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-C3 AIRCROSS": {
   "yil": 2024,
   "paket": [
    "YOU",
    "PLUS",
    "MAX"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-C4": {
   "yil": 2020,
   "paket": [
    "FEEL",
    "SHINE",
    "MAX"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-C4 X": {
   "yil": 2023,
   "paket": [
    "FEEL",
    "SHINE",
    "MAX"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "E-C5 AIRCROSS": {
   "yil": 2025,
   "paket": [
    "PLUS",
    "MAX"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "CUPRA": {
  "ATECA": {
   "yil": 2018,
   "paket": [
    "300",
    "310",
    "VZ"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TSI"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "7 İLERI DSG"
   ]
  },
  "LEON": {
   "yil": 2020,
   "paket": [
    "V",
    "VZ",
    "VZ2",
    "VZ3"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.5 TSI",
    "2.0 TSI",
    "1.4 E-HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "6 İLERI MANUEL",
    "7 İLERI DSG"
   ]
  },
  "LEON SPORTSTOURER": {
   "yil": 2020,
   "paket": [
    "VZ",
    "VZ2",
    "VZ3"
   ],
   "kasa": [
    "STATION WAGON"
   ],
   "motor": [
    "2.0 TSI",
    "1.4 E-HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "7 İLERI DSG"
   ]
  },
  "FORMENTOR": {
   "yil": 2020,
   "paket": [
    "V",
    "VZ",
    "VZ2",
    "VZ3"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "1.5 TSI",
    "2.0 TSI",
    "1.4 E-HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "6 İLERI MANUEL",
    "7 İLERI DSG"
   ]
  },
  "BORN": {
   "yil": 2021,
   "paket": [
    "V",
    "V1",
    "V2",
    "V3",
    "VZ"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "58 KWH",
    "77 KWH",
    "79 KWH"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "TAVASCAN": {
   "yil": 2024,
   "paket": [
    "ENDURANCE",
    "VZ"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "77 KWH",
    "82 KWH"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "TERRAMAR": {
   "yil": 2024,
   "paket": [
    "V",
    "VZ",
    "VZ E-HYBRID"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 ETSI",
    "2.0 TSI",
    "1.5 E-HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "7 İLERI DSG"
   ]
  },
  "RAVAL": {
   "yil": 2026,
   "paket": [
    "BASE",
    "V",
    "VZ"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "DACIA": {
  "LOGAN": {
   "yil": 2004,
   "paket": [
    "AMBIANCE",
    "LAUREATE",
    "PRESTIGE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.4",
    "1.6",
    "1.0 TCE",
    "1.5 DCI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "LPG"
   ],
   "sanziman": [
    "MANUEL",
    "EASY-R",
    "CVT"
   ]
  },
  "SANDERO": {
   "yil": 2008,
   "paket": [
    "AMBIANCE",
    "LAUREATE",
    "STEPWAY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.0 SCE",
    "1.0 TCE",
    "1.4",
    "1.6",
    "1.5 DCI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "LPG"
   ],
   "sanziman": [
    "MANUEL",
    "EASY-R",
    "CVT"
   ]
  },
  "SANDERO STEPWAY": {
   "yil": 2009,
   "paket": [
    "AMBIANCE",
    "LAUREATE",
    "PRESTIGE",
    "ESSENTIAL",
    "EXTREME"
   ],
   "kasa": [
    "CROSSOVER"
   ],
   "motor": [
    "1.0 TCE",
    "0.9 TCE",
    "1.5 DCI",
    "1.0 ECO-G"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "LPG"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "EDC"
   ]
  },
  "DUSTER": {
   "yil": 2010,
   "paket": [
    "AMBIANCE",
    "LAUREATE",
    "PRESTIGE",
    "COMFORT",
    "PRESTIGE PLUS",
    "EXTREME"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.0 TCE",
    "1.2 TCE",
    "1.3 TCE",
    "1.5 DCI",
    "1.6 SCE",
    "1.6 HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "LPG",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "EDC",
    "CVT",
    "OTOMATIK"
   ]
  },
  "LODGY": {
   "yil": 2012,
   "paket": [
    "AMBIANCE",
    "LAUREATE",
    "STEPWAY"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "1.2 TCE",
    "1.6 MPI",
    "1.5 DCI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "EDC"
   ]
  },
  "DOKKER": {
   "yil": 2012,
   "paket": [
    "AMBIANCE",
    "LAUREATE",
    "STEPWAY"
   ],
   "kasa": [
    "PANELVAN",
    "MPV"
   ],
   "motor": [
    "1.2 TCE",
    "1.6 MPI",
    "1.5 DCI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "LPG"
   ],
   "sanziman": [
    "MANUEL",
    "EASY-R"
   ]
  },
  "DOKKER VAN": {
   "yil": 2012,
   "paket": [
    "AMBIANCE",
    "COMFORT"
   ],
   "kasa": [
    "PANELVAN"
   ],
   "motor": [
    "1.6 MPI",
    "1.5 DCI"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "SPRING": {
   "yil": 2021,
   "paket": [
    "COMFORT",
    "EXTREME",
    "EXPRESSION"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "JOGGER": {
   "yil": 2022,
   "paket": [
    "ESSENTIAL",
    "EXPRESSION",
    "EXTREME"
   ],
   "kasa": [
    "MPV",
    "7 KOLTUK"
   ],
   "motor": [
    "1.0 TCE",
    "1.0 ECO-G",
    "HYBRID 140",
    "HYBRID 155"
   ],
   "yakit": [
    "BENZIN",
    "LPG",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "MULTI-MODE OTOMATIK"
   ]
  },
  "BIGSTER": {
   "yil": 2025,
   "paket": [
    "ESSENTIAL",
    "EXPRESSION",
    "EXTREME",
    "JOURNEY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2 TCE MILD HYBRID",
    "1.6 HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "MULTI-MODE OTOMATIK"
   ]
  }
 },
 "GAC": {
  "GS3": {
   "yil": 2023,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GS4": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GS5": {
   "yil": 2011,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GS8": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EMKOO": {
   "yil": 2022,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "AION S": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "AION Y": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "GAZ": {
  "VOLGA 3110": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "VOLGA 31105": {
   "yil": 2004,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GAZELLE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "VAN",
    "KOMBI",
    "CHASSIS"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS",
    "ŞASI"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL",
    "2.4",
    "2.8 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "SOBOL": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "VAN",
    "COMBI"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL",
    "2.5",
    "2.8 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "GEELY": {
  "EMGRAND": {
   "yil": 2009,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EMGRAND EC7": {
   "yil": 2009,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "COOLRAY": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ATLAS": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MONJARO": {
   "yil": 2021,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TUGELLA": {
   "yil": 2019,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GEOMETRY C": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "STARRAY": {
   "yil": 2022,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "GENESIS": {
  "G70": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "G80": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "G90": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GV60": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "GV70": {
   "yil": 2020,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GV80": {
   "yil": 2020,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "GMC": {
  "SIERRA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "YUKON": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "YUKON XL": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TERRAIN": {
   "yil": 2010,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ACADIA": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CANYON": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "GREAT WALL": {
  "HOVER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "WINGLE 5": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "WINGLE 6": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "HAVAL H2": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HAVAL H6": {
   "yil": 2011,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HAVAL JOLION": {
   "yil": 2020,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HAVAL H9": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "HONDA": {
  "JAZZ": {
   "yil": 2001,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CIVIC": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ACCORD": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CR-V": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HR-V": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CIVIC TYPE R": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CITY": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "PCX 125": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "PCX 160": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "160 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "FORZA 250": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "250 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "FORZA 350": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "350 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "SH125I": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "SH150I": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "CB125F": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "CB250R": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "250 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "CB500F": {
   "yil": 2013,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "471 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "CB650R": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "649 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "CBR500R": {
   "yil": 2013,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "471 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "CBR650R": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "649 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "AFRICA TWIN": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1084 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL",
    "DCT"
   ]
  },
  "GOLD WING": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "TOURING"
   ],
   "motor": [
    "1833 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "7 İLERI DCT"
   ]
  }
 },
 "HUMMER": {
  "H1": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "H2": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "H3": {
   "yil": 2005,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EV": {
   "yil": 2021,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP",
    "SUV"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "HYUNDAI": {
  "I10": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "I20": {
   "yil": 2008,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "I30": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ACCENT": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ELANTRA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SONATA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "KONA": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TUCSON": {
   "yil": 2004,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SANTA FE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "I20 N": {
   "yil": 2021,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "IONIQ 5": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "CROSSOVER"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "IONIQ 6": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "IONIQ 9": {
   "yil": 2025,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "INSTER": {
   "yil": 2024,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "H-1": {
   "yil": 2000,
   "paket": [
    "PANELVAN",
    "STAREX",
    "TRAVEL"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "2.5 CRDI",
    "2.4"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "5AT"
   ]
  },
  "STARIA": {
   "yil": 2021,
   "paket": [
    "CARGO",
    "PRIME",
    "ELITE"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "2.2 CRDI",
    "1.6 HYBRID"
   ],
   "yakit": [
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "8AT",
    "6AT"
   ]
  },
  "HD35": {
   "yil": 2000,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "KAMYONET"
   ],
   "motor": [
    "2.5 CRDI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  }
 },
 "INFINITI": {
  "G": {
   "yil": 2002,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SEDAN",
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "FX": {
   "yil": 2003,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EX": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "Q30": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "Q50": {
   "yil": 2013,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "QX50": {
   "yil": 2013,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "QX60": {
   "yil": 2012,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "QX80": {
   "yil": 2010,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "ISUZU": {
  "D-MAX": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "SINGLE CAB",
    "SPACE CAB",
    "V-CROSS"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL",
    "1.9",
    "2.5",
    "3.0 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "6AT"
   ]
  },
  "TROOPER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "NPR": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "NPR 3D",
    "8",
    "10"
   ],
   "kasa": [
    "KAMYONET"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL",
    "3.0",
    "5.2 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "NQR": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "NQR"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL",
    "3.0",
    "5.2 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "JAGUAR": {
  "X-TYPE": {
   "yil": 2001,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "S-TYPE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "XF": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "XE": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "F-PACE": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "E-PACE": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "F-TYPE": {
   "yil": 2013,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "I-PACE": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "JEEP": {
  "RENEGADE": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "COMPASS": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CHEROKEE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GRAND CHEROKEE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "WRANGLER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GLADIATOR": {
   "yil": 2019,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "AVENGER": {
   "yil": 2023,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "KIA": {
  "PICANTO": {
   "yil": 2004,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RIO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CEED": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CERATO": {
   "yil": 2004,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SPORTAGE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SORENTO": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "STONIC": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "NIRO": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EV6": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "CROSSOVER"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "EV9": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "BONGO": {
   "yil": 2000,
   "paket": [
    "K2500",
    "K2700",
    "K2900"
   ],
   "kasa": [
    "KAMYONET"
   ],
   "motor": [
    "2.5",
    "2.9 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "PREGIO": {
   "yil": 2000,
   "paket": [
    "PANELVAN",
    "COMBI"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "2.7 DIESEL",
    "3.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  }
 },
 "KOENIGSEGG": {
  "CCX": {
   "yil": 2006,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "AGERA": {
   "yil": 2010,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "REGERA": {
   "yil": 2016,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "JESKO": {
   "yil": 2019,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GEMERA": {
   "yil": 2020,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "GRAND TOURER"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "LAMBORGHINI": {
  "GALLARDO": {
   "yil": 2003,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MURCIELAGO": {
   "yil": 2001,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "AVENTADOR": {
   "yil": 2011,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "ROADSTER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HURACAN": {
   "yil": 2014,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SPYDER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "URUS": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "REVUELTO": {
   "yil": 2023,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "LAND ROVER": {
  "FREELANDER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RANGE ROVER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RANGE ROVER SPORT": {
   "yil": 2005,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "DISCOVERY": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "DISCOVERY SPORT": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RANGE ROVER EVOQUE": {
   "yil": 2011,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "DEFENDER": {
   "yil": 2020,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "LEXUS": {
  "IS": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GS": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LS": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RX": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "NX": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "UX": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LC": {
   "yil": 2017,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LX": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "LINCOLN": {
  "NAVIGATOR": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "AVIATOR": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MKZ": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CORSAIR": {
   "yil": 2019,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "NAUTILUS": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "LOTUS": {
  "ELISE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EXIGE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EVORA": {
   "yil": 2009,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EMIRA": {
   "yil": 2022,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ELETRE": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "MASERATI": {
  "3200 GT": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "COUPE": {
   "yil": 2002,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "QUATTROPORTE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GRANTURISMO": {
   "yil": 2007,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GHIBLI": {
   "yil": 2013,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LEVANTE": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MC20": {
   "yil": 2020,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GRECALE": {
   "yil": 2022,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "MAYBACH": {
  "MAYBACH 57": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MAYBACH 62": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MERCEDES-MAYBACH S-SERISI": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MERCEDES-MAYBACH GLS": {
   "yil": 2019,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "MAZDA": {
  "MAZDA2": {
   "yil": 2003,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MAZDA3": {
   "yil": 2003,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MAZDA6": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CX-3": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CX-5": {
   "yil": 2012,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CX-30": {
   "yil": 2019,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CX-60": {
   "yil": 2022,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MX-5": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "MCLAREN": {
  "MP4-12C": {
   "yil": 2011,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SPIDER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "650S": {
   "yil": 2014,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SPIDER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "570S": {
   "yil": 2015,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SPIDER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "720S": {
   "yil": 2017,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SPIDER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GT": {
   "yil": 2019,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ARTURA": {
   "yil": 2021,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SPIDER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "750S": {
   "yil": 2023,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SPIDER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "MERCEDES-BENZ": {
  "A-SERISI": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "B-SERISI": {
   "yil": 2005,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "C-SERISI": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SEDAN",
    "ESTATE",
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "E-SERISI": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SEDAN",
    "ESTATE",
    "COUPE",
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "S-SERISI": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CLA": {
   "yil": 2013,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "SHOOTING BRAKE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GLA": {
   "yil": 2013,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GLB": {
   "yil": 2019,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GLC": {
   "yil": 2015,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV",
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GLE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV",
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GLS": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "G-SERISI": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EQA": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "EQB": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "EQE": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "EQS": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "SPRINTER": {
   "yil": 2000,
   "paket": [
    "PANELVAN",
    "MINIBÜS",
    "ŞASI"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS",
    "ŞASI"
   ],
   "motor": [
    "2.1 CDI",
    "2.0 CDI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "7G-TRONIC",
    "9G-TRONIC"
   ]
  },
  "VITO": {
   "yil": 2000,
   "paket": [
    "PANELVAN",
    "MIXTO",
    "TOURER"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "2.0 CDI",
    "2.2 CDI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "7AT",
    "9AT"
   ]
  },
  "ESPRINTER": {
   "yil": 2019,
   "paket": [
    "PANELVAN"
   ],
   "kasa": [
    "PANELVAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ACTROS": {
   "yil": 2000,
   "paket": [
    "1845",
    "1851",
    "2553",
    "2653",
    "3353"
   ],
   "kasa": [
    "ÇEKICI",
    "KAMYON"
   ],
   "motor": [
    "11.9",
    "12.8",
    "15.6 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "12 İLERI OTOMATIK"
   ]
  },
  "AROCS": {
   "yil": 2013,
   "paket": [
    "1842",
    "2642",
    "3240",
    "4145"
   ],
   "kasa": [
    "KAMYON",
    "ÇEKICI"
   ],
   "motor": [
    "7.7",
    "10.7",
    "12.8",
    "15.6 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "8",
    "12 İLERI OTOMATIK"
   ]
  },
  "ATEGO": {
   "yil": 2000,
   "paket": [
    "1518",
    "1624",
    "1824",
    "2524"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "4.25",
    "6.37",
    "7.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "6",
    "8 İLERI MANUEL",
    "OTOMATIK"
   ]
  },
  "EACTROS": {
   "yil": 2021,
   "paket": [
    "300",
    "400",
    "600"
   ],
   "kasa": [
    "KAMYON",
    "ÇEKICI"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "MG": {
  "MG3": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ZS": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HS": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ZS EV": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "MARVEL R": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "4": {
   "yil": 2024,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "MINI": {
  "MINI HATCH": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MINI CABRIO": {
   "yil": 2004,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CLUBMAN": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "COUNTRYMAN": {
   "yil": 2010,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "PACEMAN": {
   "yil": 2013,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MINI COOPER E": {
   "yil": 2024,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "MITSUBISHI": {
  "COLT": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LANCER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ASX": {
   "yil": 2010,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "OUTLANDER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "PAJERO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "L200": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "ECLIPSE CROSS": {
   "yil": 2017,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "NIO": {
  "ES6": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ES8": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 6",
    "7 KOLTUK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "EC6": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ET5": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ET7": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "EL7": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "NISSAN": {
  "MICRA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ALMERA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "NOTE": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "MPV",
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "QASHQAI": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "JUKE": {
   "yil": 2010,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "X-TRAIL": {
   "yil": 2001,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 5",
    "7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "NAVARA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "LEAF": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ARIYA": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "OPEL": {
  "CORSA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ASTRA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "INSIGNIA": {
   "yil": 2008,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "LIFTBACK",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MOKKA": {
   "yil": 2012,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CROSSLAND": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GRANDLAND": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ZAFIRA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "COMBO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PANELVAN",
    "MPV"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "PAGANI": {
  "ZONDA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "ROADSTER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HUAYRA": {
   "yil": 2011,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "ROADSTER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "UTOPIA": {
   "yil": 2022,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "ROADSTER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "PEUGEOT": {
  "206": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "CC"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "207": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SW",
    "CC"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "208": {
   "yil": 2012,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "301": {
   "yil": 2012,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "308": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SW"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "508": {
   "yil": 2010,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "SW"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "2008": {
   "yil": 2013,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "3008": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "5008": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RIFTER": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "MPV",
    "PANELVAN"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "POLESTAR": {
  "POLESTAR 1": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "POLESTAR 2": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "FASTBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "POLESTAR 3": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "POLESTAR 4": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "POLESTAR 5": {
   "yil": 2025,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "PORSCHE": {
  "911": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE",
    "CABRIO",
    "TARGA"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "BOXSTER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CAYMAN": {
   "yil": 2005,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CAYENNE": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "PANAMERA": {
   "yil": 2009,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "SPORT TURISMO"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MACAN": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TAYCAN": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "SPORT TURISMO"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "RAM": {
  "1500": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "2500": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "3500": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "PROMASTER": {
   "yil": 2013,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PANELVAN"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "RENAULT": {
  "CLIO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MEGANE": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN",
    "ESTATE"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "FLUENCE": {
   "yil": 2009,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SYMBOL": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CAPTUR": {
   "yil": 2013,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "KADJAR": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TALISMAN": {
   "yil": 2015,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "ESTATE"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "AUSTRAL": {
   "yil": 2022,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ARKANA": {
   "yil": 2019,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "MEGANE E-TECH": {
   "yil": 2022,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SCENIC E-TECH": {
   "yil": 2023,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "MPV",
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RAFALE": {
   "yil": 2024,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "ROLLS-ROYCE": {
  "PHANTOM": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GHOST": {
   "yil": 2009,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "WRAITH": {
   "yil": 2013,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "DAWN": {
   "yil": 2015,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "CABRIO"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CULLINAN": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SPECTRE": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "SAAB": {
  "9-3": {
   "yil": 2000,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SEDAN",
    "CABRIO",
    "STATION WAGON"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "9-5": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "ESTATE"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "SEAT": {
  "IBIZA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LEON": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TOLEDO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "LIFTBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ALTEA": {
   "yil": 2004,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ATECA": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ARONA": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TARRACO": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "SKODA": {
  "FABIA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "OCTAVIA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "LIFTBACK",
    "COMBI"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SUPERB": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "COMBI"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RAPID": {
   "yil": 2012,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SPACEBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "YETI": {
   "yil": 2009,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "KAROQ": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "KODIAQ": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "KAMIQ": {
   "yil": 2019,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ENYAQ": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "SMART": {
  "FORTWO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "FORFOUR": {
   "yil": 2004,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EQ FORTWO": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "EQ FORFOUR": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "#1": {
   "yil": 2022,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "#3": {
   "yil": 2023,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "SUBARU": {
  "IMPREZA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LEGACY": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "FORESTER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "OUTBACK": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "STATION WAGON",
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "XV / CROSSTREK": {
   "yil": 2011,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "CROSSOVER"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "BRZ": {
   "yil": 2012,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "WRX": {
   "yil": 2014,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SOLTERRA": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "SUZUKI": {
  "SWIFT": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "IGNIS": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "JIMNY": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "VITARA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "S-CROSS": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "SX4": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ACROSS": {
   "yil": 2020,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ADDRESS 110": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "113 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "BURGMAN 125": {
   "yil": 2002,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "BURGMAN 400": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "400 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "GSX-R125": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "GSX-R750": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "750 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "GSX-R1000": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "999 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SV650": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "645 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "V-STROM 650": {
   "yil": 2004,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "645 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "V-STROM 1050": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1037 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "HAYABUSA": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT TOURING"
   ],
   "motor": [
    "1340 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "TESLA": {
  "MODEL S": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "MODEL X": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "MODEL 3": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "MODEL Y": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "CYBERTRUCK": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "TOYOTA": {
  "YARIS": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "COROLLA": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "HATCHBACK",
    "TOURING"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CAMRY": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "AVENSIS": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "AURIS": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "C-HR": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "RAV4": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "LAND CRUISER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "HILUX": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "ACTIVE",
    "ADVENTURE",
    "INVINCIBLE"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL",
    "2.5",
    "2.4",
    "2.8 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "6AT"
   ]
  },
  "PROACE": {
   "yil": 2016,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "ACTIVE",
    "CITY"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL",
    "2.0 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "8AT"
   ]
  },
  "BZ4X": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "PROACE CITY": {
   "yil": 2019,
   "paket": [
    "DREAM",
    "FLAME",
    "PASSION"
   ],
   "kasa": [
    "PANELVAN",
    "KOMBI"
   ],
   "motor": [
    "1.5 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  },
  "PROACE MAX": {
   "yil": 2024,
   "paket": [
    "CARGO",
    "PANEL VAN"
   ],
   "kasa": [
    "PANELVAN"
   ],
   "motor": [
    "2.2 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  }
 },
 "VOLKSWAGEN": {
  "POLO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "GOLF": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK",
    "VARIANT"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "PASSAT": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN",
    "VARIANT"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "JETTA": {
   "yil": 2005,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TIGUAN": {
   "yil": 2007,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TOUAREG": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "T-ROC": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "T-CROSS": {
   "yil": 2018,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "TAIGO": {
   "yil": 2021,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ID.3": {
   "yil": 2019,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ID.4": {
   "yil": 2020,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ID.5": {
   "yil": 2021,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "ID.7": {
   "yil": 2023,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "FASTBACK",
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "CADDY": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PANELVAN",
    "MPV"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "TRANSPORTER": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "1.5",
    "2.0",
    "2.5 TURBO DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "VOLVO": {
  "S40": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "S60": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "S80": {
   "yil": 2000,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "V40": {
   "yil": 2012,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "V60": {
   "yil": 2010,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "STATION WAGON"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "XC40": {
   "yil": 2017,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "XC60": {
   "yil": 2008,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "XC90": {
   "yil": 2002,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "C40 RECHARGE": {
   "yil": 2021,
   "paket": [
    "BASE",
    "SPORT",
    "PREMIUM"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 V6",
    "4.0 V8"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EX30": {
   "yil": 2023,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  },
  "EX90": {
   "yil": 2024,
   "paket": [
    "BASE",
    "COMFORT",
    "PREMIUM",
    "LUXURY"
   ],
   "kasa": [
    "SUV 7 KOLTUK"
   ],
   "motor": [
    "1.2",
    "1.5 TURBO",
    "2.0 TURBO",
    "2.0 DIESEL",
    "HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "DIZEL",
    "HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "CVT",
    "OTOMATIK",
    "DCT"
   ]
  }
 },
 "FORD OTOSAN": {
  "TRANSIT": {
   "yil": 2000,
   "paket": [
    "VAN",
    "KOMBI",
    "MINIBÜS"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "2.0",
    "2.2",
    "2.4",
    "2.5",
    "2.0 ECOBLUE"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "TRANSIT CUSTOM": {
   "yil": 2012,
   "paket": [
    "TREND",
    "LIMITED",
    "ACTIVE"
   ],
   "kasa": [
    "PANELVAN",
    "KOMBI"
   ],
   "motor": [
    "2.0 ECOBLUE",
    "PHEV"
   ],
   "yakit": [
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  },
  "TOURNEO CUSTOM": {
   "yil": 2012,
   "paket": [
    "TREND",
    "TITANIUM",
    "ACTIVE"
   ],
   "kasa": [
    "MINIBÜS"
   ],
   "motor": [
    "2.0 ECOBLUE",
    "PHEV"
   ],
   "yakit": [
    "DIZEL",
    "PLUG-IN HIBRIT"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  },
  "TRANSIT COURIER": {
   "yil": 2014,
   "paket": [
    "TREND",
    "DELUXE",
    "TITANIUM"
   ],
   "kasa": [
    "PANELVAN",
    "KOMBI"
   ],
   "motor": [
    "1.5 TDCI",
    "1.0 ECOBOOST"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  },
  "TOURNEO COURIER": {
   "yil": 2014,
   "paket": [
    "TREND",
    "TITANIUM",
    "ACTIVE"
   ],
   "kasa": [
    "MINIBÜS"
   ],
   "motor": [
    "1.5 TDCI",
    "1.0 ECOBOOST"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  },
  "E-TRANSIT": {
   "yil": 2022,
   "paket": [
    "TREND",
    "LIMITED"
   ],
   "kasa": [
    "PANELVAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "FORD TRUCKS CARGO": {
   "yil": 2000,
   "paket": [
    "4X2",
    "6X2",
    "6X4",
    "8X2"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "7.3",
    "9.0",
    "13.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "F-MAX": {
   "yil": 2018,
   "paket": [
    "F-MAX",
    "F-MAX PLUS"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "12.7 ECOTORQ"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "12 İLERI OTOMATIK"
   ]
  }
 },
 "TOFAŞ (FIAT)": {
  "DUCATO": {
   "yil": 2000,
   "paket": [
    "CARGO",
    "MAXI",
    "PANORAMA"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS",
    "ŞASI"
   ],
   "motor": [
    "2.0",
    "2.3 MULTIJET",
    "2.2 MULTIJET"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "9AT"
   ]
  },
  "DOBLO": {
   "yil": 2000,
   "paket": [
    "CARGO",
    "COMBI",
    "PREMIO"
   ],
   "kasa": [
    "PANELVAN",
    "KOMBI"
   ],
   "motor": [
    "1.2",
    "1.3 MULTIJET",
    "1.6 MULTIJET",
    "1.5 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "DCT"
   ]
  },
  "FIORINO": {
   "yil": 2007,
   "paket": [
    "CARGO",
    "COMBI",
    "PREMIO"
   ],
   "kasa": [
    "PANELVAN",
    "KOMBI"
   ],
   "motor": [
    "1.3 MULTIJET",
    "1.4 FIRE"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "DUALOGIC"
   ]
  },
  "SCUDO": {
   "yil": 2000,
   "paket": [
    "CARGO",
    "COMBI"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "1.6",
    "2.0 JTD",
    "2.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  }
 },
 "ANADOLU ISUZU": {
  "NPR": {
   "yil": 2000,
   "paket": [
    "NPR 3D",
    "8",
    "10"
   ],
   "kasa": [
    "KAMYONET"
   ],
   "motor": [
    "3.0",
    "5.2 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "NQR": {
   "yil": 2000,
   "paket": [
    "NQR 3D",
    "10",
    "13"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "3.0",
    "5.2 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "D-MAX": {
   "yil": 2002,
   "paket": [
    "SINGLE CAB",
    "SPACE CAB",
    "V-CROSS"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "1.9",
    "2.5",
    "3.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "6AT"
   ]
  },
  "NOVOCITI": {
   "yil": 2008,
   "paket": [
    "STANDARD",
    "LIFE"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "4.5 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "NOVOCITI LIFE": {
   "yil": 2017,
   "paket": [
    "C",
    "S",
    "LIFE"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "4.5 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CITIPORT": {
   "yil": 2014,
   "paket": [
    "12",
    "18"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "7.7",
    "9.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "KENDO": {
   "yil": 2021,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "KARSAN": {
  "JEST": {
   "yil": 2013,
   "paket": [
    "JEST",
    "JEST+"
   ],
   "kasa": [
    "MINIBÜS"
   ],
   "motor": [
    "2.3 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "JEST ELECTRIC": {
   "yil": 2018,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "MINIBÜS"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  },
  "ATAK": {
   "yil": 2014,
   "paket": [
    "ATAK"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "4.5 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ATAK ELECTRIC": {
   "yil": 2019,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "E-ATAK": {
   "yil": 2021,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "E-ATA": {
   "yil": 2021,
   "paket": [
    "10",
    "12",
    "18 M"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "OTOKAR": {
  "SULTAN": {
   "yil": 2000,
   "paket": [
    "SULTAN",
    "SULTAN MEGA"
   ],
   "kasa": [
    "MINIBÜS",
    "MIDIBÜS"
   ],
   "motor": [
    "3.0",
    "4.5 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "DORUK": {
   "yil": 2000,
   "paket": [
    "DORUK 190S",
    "220LE"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "6.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "KENT": {
   "yil": 2009,
   "paket": [
    "KENT LF",
    "KENT C"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "6.7",
    "7.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "KENT ELECTRA": {
   "yil": 2021,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ATLAS": {
   "yil": 2013,
   "paket": [
    "3.5",
    "5.5",
    "8.5"
   ],
   "kasa": [
    "KAMYONET"
   ],
   "motor": [
    "2.8",
    "3.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  }
 },
 "BMC": {
  "PROBUS": {
   "yil": 2000,
   "paket": [
    "PROBUS"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "7.2",
    "9.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "NEOCITY": {
   "yil": 2000,
   "paket": [
    "NEOCITY"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "6.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "LEVEND": {
   "yil": 2000,
   "paket": [
    "LEVEND"
   ],
   "kasa": [
    "MINIBÜS"
   ],
   "motor": [
    "2.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "PRO 1142": {
   "yil": 2000,
   "paket": [
    "4X2",
    "6X2"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "11.1 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "PRO 1144": {
   "yil": 2000,
   "paket": [
    "4X2",
    "6X2"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "11.1 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "PRO L 1852": {
   "yil": 2024,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "12.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "12 İLERI OTOMATIK"
   ]
  }
 },
 "TEMSA": {
  "PRESTIJ": {
   "yil": 2000,
   "paket": [
    "PRESTIJ",
    "PRESTIJ SX"
   ],
   "kasa": [
    "MINIBÜS",
    "MIDIBÜS"
   ],
   "motor": [
    "3.0",
    "4.5 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "MD9": {
   "yil": 2008,
   "paket": [
    "MD9 LE",
    "MD9 ELECTRICITY"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "6.7 DIESEL",
    "ELEKTRIK"
   ],
   "yakit": [
    "DIZEL",
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "MD9 ELECTRICITY": {
   "yil": 2015,
   "paket": [
    "STANDARD"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "AVENUE": {
   "yil": 2008,
   "paket": [
    "AVENUE LF",
    "AVENUE ELECTRON"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "7.7 DIESEL",
    "ELEKTRIK"
   ],
   "yakit": [
    "DIZEL",
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "MARATON": {
   "yil": 2015,
   "paket": [
    "MARATON"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "12.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "SAFIR": {
   "yil": 2000,
   "paket": [
    "SAFIR",
    "SAFIR PLUS"
   ],
   "kasa": [
    "OTOBÜS"
   ],
   "motor": [
    "7.7",
    "10.8",
    "12.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "IVECO": {
  "DAILY": {
   "yil": 2000,
   "paket": [
    "VAN",
    "CHASSIS CAB",
    "MINIBUS"
   ],
   "kasa": [
    "PANELVAN",
    "ŞASI",
    "MINIBÜS"
   ],
   "motor": [
    "2.3",
    "3.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "HI-MATIC 8AT"
   ]
  },
  "EUROCARGO": {
   "yil": 2000,
   "paket": [
    "ML",
    "ML-MID"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "4.5",
    "6.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "S-WAY": {
   "yil": 2019,
   "paket": [
    "AS",
    "LNG",
    "NATURAL POWER"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "9.0",
    "11.1",
    "12.9 DIESEL"
   ],
   "yakit": [
    "DIZEL",
    "CNG"
   ],
   "sanziman": [
    "12 İLERI OTOMATIK"
   ]
  },
  "X-WAY": {
   "yil": 2017,
   "paket": [
    "4X2",
    "6X2",
    "6X4"
   ],
   "kasa": [
    "KAMYON",
    "ÇEKICI"
   ],
   "motor": [
    "9.0",
    "11.1",
    "12.9 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "12 İLERI OTOMATIK"
   ]
  }
 },
 "SCANIA": {
  "P SERISI": {
   "yil": 2000,
   "paket": [
    "P 4X2",
    "6X2",
    "6X4"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "7.0",
    "9.0",
    "13.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OPTICRUISE"
   ]
  },
  "G SERISI": {
   "yil": 2000,
   "paket": [
    "G 4X2",
    "6X2",
    "6X4"
   ],
   "kasa": [
    "KAMYON",
    "ÇEKICI"
   ],
   "motor": [
    "9.0",
    "13.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OPTICRUISE"
   ]
  },
  "R SERISI": {
   "yil": 2000,
   "paket": [
    "R 4X2",
    "6X2",
    "6X4"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "13.0",
    "16.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OPTICRUISE"
   ]
  },
  "S SERISI": {
   "yil": 2016,
   "paket": [
    "S 4X2",
    "6X2"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "13.0",
    "16.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OPTICRUISE"
   ]
  }
 },
 "VOLVO TRUCKS": {
  "FH": {
   "yil": 2000,
   "paket": [
    "FH 4X2",
    "6X2",
    "6X4"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "12.0",
    "13.0",
    "16.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "I-SHIFT"
   ]
  },
  "FM": {
   "yil": 2000,
   "paket": [
    "FM 4X2",
    "6X2",
    "6X4"
   ],
   "kasa": [
    "KAMYON",
    "ÇEKICI"
   ],
   "motor": [
    "7.7",
    "10.8",
    "12.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "I-SHIFT"
   ]
  },
  "FE": {
   "yil": 2000,
   "paket": [
    "FE 4X2",
    "6X2"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "7.0",
    "8.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "I-SHIFT"
   ]
  },
  "FL": {
   "yil": 2000,
   "paket": [
    "FL 4X2"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "5.1",
    "7.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "I-SHIFT",
    "MANUEL"
   ]
  }
 },
 "MAN": {
  "TGL": {
   "yil": 2000,
   "paket": [
    "TGL 8.180",
    "10.180",
    "12.250"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "4.6",
    "6.9 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "TIPMATIC"
   ]
  },
  "TGM": {
   "yil": 2000,
   "paket": [
    "TGM 15.250",
    "18.290",
    "18.320"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "6.9",
    "10.5 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "TIPMATIC"
   ]
  },
  "TGS": {
   "yil": 2000,
   "paket": [
    "TGS 18.400",
    "26.430",
    "33.400"
   ],
   "kasa": [
    "KAMYON",
    "ÇEKICI"
   ],
   "motor": [
    "10.5",
    "12.4",
    "15.2 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "TIPMATIC"
   ]
  },
  "TGX": {
   "yil": 2000,
   "paket": [
    "TGX 18.440",
    "26.480",
    "33.640"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "12.4",
    "15.2 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "TIPMATIC"
   ]
  }
 },
 "DAF": {
  "LF": {
   "yil": 2000,
   "paket": [
    "LF 45",
    "LF 55"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "4.5",
    "6.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CF": {
   "yil": 2000,
   "paket": [
    "CF 75",
    "CF 85"
   ],
   "kasa": [
    "KAMYON",
    "ÇEKICI"
   ],
   "motor": [
    "9.2",
    "12.9 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "AS-TRONIC"
   ]
  },
  "XF": {
   "yil": 2000,
   "paket": [
    "XF 95",
    "XF 105"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "12.6",
    "12.9 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "AS-TRONIC",
    "TRAXON"
   ]
  },
  "XG": {
   "yil": 2021,
   "paket": [
    "XG 480",
    "XG 530"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "12.9",
    "12.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "TRAXON"
   ]
  }
 },
 "RENAULT TRUCKS": {
  "MASTER": {
   "yil": 2000,
   "paket": [
    "VAN",
    "CHASSIS"
   ],
   "kasa": [
    "PANELVAN",
    "ŞASI"
   ],
   "motor": [
    "2.3 DCI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "9AT"
   ]
  },
  "D": {
   "yil": 2000,
   "paket": [
    "D 7.5",
    "D 10",
    "D 16",
    "D 18"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "5.1",
    "7.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OPTIDRIVER"
   ]
  },
  "C": {
   "yil": 2000,
   "paket": [
    "C 4X2",
    "6X2",
    "6X4"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "7.7",
    "10.8",
    "12.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OPTIDRIVER"
   ]
  },
  "K": {
   "yil": 2013,
   "paket": [
    "K 4X2",
    "6X4",
    "8X4"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "10.8",
    "12.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OPTIDRIVER"
   ]
  },
  "T": {
   "yil": 2013,
   "paket": [
    "T 4X2",
    "6X2"
   ],
   "kasa": [
    "ÇEKICI"
   ],
   "motor": [
    "11.1",
    "12.8 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "OPTIDRIVER"
   ]
  }
 },
 "VOLKSWAGEN TICARI ARAÇ": {
  "CADDY": {
   "yil": 2000,
   "paket": [
    "CARGO",
    "LIFE",
    "STYLE"
   ],
   "kasa": [
    "PANELVAN",
    "KOMBI"
   ],
   "motor": [
    "1.9 TDI",
    "2.0 TDI",
    "1.5 TSI"
   ],
   "yakit": [
    "DIZEL",
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "DSG"
   ]
  },
  "TRANSPORTER": {
   "yil": 2000,
   "paket": [
    "PANELVAN",
    "KOMBI",
    "SHUTTLE"
   ],
   "kasa": [
    "PANELVAN",
    "MINIBÜS"
   ],
   "motor": [
    "2.0 TDI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "DSG"
   ]
  },
  "CRAFTER": {
   "yil": 2006,
   "paket": [
    "PANELVAN",
    "KAMYONET",
    "MINIBÜS"
   ],
   "kasa": [
    "PANELVAN",
    "ŞASI",
    "MINIBÜS"
   ],
   "motor": [
    "2.0 TDI"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "8AT"
   ]
  },
  "ID. BUZZ": {
   "yil": 2022,
   "paket": [
    "PRO",
    "CARGO",
    "LONG"
   ],
   "kasa": [
    "MINIBÜS",
    "PANELVAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "MITSUBISHI FUSO": {
  "CANTER": {
   "yil": 2000,
   "paket": [
    "3S13",
    "3C13",
    "7C18",
    "9C18"
   ],
   "kasa": [
    "KAMYONET",
    "KAMYON"
   ],
   "motor": [
    "3.0",
    "4.9 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "DUONIC"
   ]
  }
 },
 "HINO": {
  "300": {
   "yil": 2000,
   "paket": [
    "300 SERIES"
   ],
   "kasa": [
    "KAMYONET"
   ],
   "motor": [
    "4.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "500": {
   "yil": 2000,
   "paket": [
    "500 SERIES"
   ],
   "kasa": [
    "KAMYON"
   ],
   "motor": [
    "5.1",
    "7.7 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  }
 },
 "FOTON": {
  "TUNLAND G7": {
   "yil": 2024,
   "paket": [
    "COMFORT",
    "LUXURY",
    "FLAGSHIP"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "2.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "8AT"
   ]
  },
  "TUNLAND V9": {
   "yil": 2024,
   "paket": [
    "LUXURY",
    "ULTRA"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "2.0 DIESEL"
   ],
   "yakit": [
    "DIZEL"
   ],
   "sanziman": [
    "8AT"
   ]
  }
 },
 "KUBA": {
  "XRS50": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "BRILLIANT 50 ST": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "VN50 GRANDE": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "NEWCITY 50": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "NEWLIGHT 50": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "BRILLIANT 125 PRO-X": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "SUPERLIGHT 125": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CHOPPER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "NOVAX 200": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "200 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "RACE 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CROSS"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "KARGO 180": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "TICARI MOTOSIKLET"
   ],
   "motor": [
    "180 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "PIKAP 200 MAX": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "TICARI MOTOSIKLET"
   ],
   "motor": [
    "200 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "ALTERA 400": {
   "yil": 2024,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "T1",
    "T3"
   ],
   "motor": [
    "400 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  }
 },
 "MONDIAL": {
  "50 ZNU": {
   "yil": 2005,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "50 REVIVAL": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "100 UAG": {
   "yil": 2005,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CUB"
   ],
   "motor": [
    "100 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "4 İLERI MANUEL"
   ]
  },
  "125 DRIFT": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "125 MH DRIFT": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "125 ZNU": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "150 WING": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "250 NEVADA": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CHOPPER"
   ],
   "motor": [
    "250 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "250 X-TREME": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CROSS"
   ],
   "motor": [
    "250 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "300 VULTURE": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "300 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "RKS": {
  "RZ 125": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "RZ 250": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "250 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "FRECCIA 150": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "NEWLIGHT 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "RKS RN 180": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "180 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "K-LIGHT 125": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CHOPPER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "K-LIGHT 250": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CHOPPER"
   ],
   "motor": [
    "250 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "BLADE 250": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "250 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "M5": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ELEKTRIKLI SCOOTER"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "ARORA": {
  "AR 50": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "CAPUCCINO 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "FREEDOM 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MAX-T 150": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "VERANO 125": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "KTM 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "KASIRGA 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  }
 },
 "TVS": {
  "APACHE RTR 160": {
   "yil": 2007,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "160 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "APACHE RTR 200 4V": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "197 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "APACHE RR 310": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "312 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "RAIDER 125": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "NTORQ 125": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "JUPITER 125": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  }
 },
 "CFMOTO": {
  "250 NK": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "249 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "300 NK": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "292 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "400 NK": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "400 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "450 NK": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "449 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "450 SR": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "449 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "650 MT": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "TOURING"
   ],
   "motor": [
    "649 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "700 MT": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "693 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "800 MT": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "799 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "450 MT": {
   "yil": 2024,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "449 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "800 MT-X": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "799 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "1250 TR-G": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "TOURING"
   ],
   "motor": [
    "1279 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "YAMAHA": {
  "NMAX 125": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "NMAX 155": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "155 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "XMAX 250": {
   "yil": 2005,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "249 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "XMAX 300": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "292 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MT-07": {
   "yil": 2014,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "689 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "MT-09": {
   "yil": 2014,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "890 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "MT-10": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "998 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "R3": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "321 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "R7": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "689 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "R1": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "998 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TENERE 700": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "689 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TRACER 9": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT TOURING"
   ],
   "motor": [
    "890 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "YZF-R125": {
   "yil": 2008,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "BAJAJ": {
  "PULSAR 125": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "PULSAR 150": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "PULSAR NS200": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "199 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "PULSAR RS200": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "199 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "DOMINAR 250": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "248 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "DOMINAR 400": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "373 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "AVENGER 160": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CHOPPER"
   ],
   "motor": [
    "160 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  }
 },
 "HERO": {
  "HUNK 150": {
   "yil": 2004,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "HUNK 160R": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "160 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "XTREME 160R": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "160 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "XPULSE 200": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "199 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "XPULSE 200 4V": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "199 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "PLEASURE+": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "110 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  }
 },
 "KANUNI": {
  "SEHA 150": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "TIGRINA 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "RESA 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MOTORAN 150": {
   "yil": 2010,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  }
 },
 "SYM": {
  "FIDDLE II 125": {
   "yil": 2008,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "FIDDLE IV 125": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "JET 14 125": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "JET X 125": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "JOYMAX Z+ 250": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "249 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MAXSYM TL 508": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "508 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "NH-T 200": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "183 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "VESPA": {
  "PRIMAVERA 50": {
   "yil": 2013,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "PRIMAVERA 125": {
   "yil": 2013,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "PRIMAVERA 150": {
   "yil": 2013,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "155 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "SPRINT 50": {
   "yil": 2014,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "SPRINT 125": {
   "yil": 2014,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "GTS 300": {
   "yil": 2003,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "278 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "GTS 310": {
   "yil": 2024,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "310 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "ELETTRICA": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ELEKTRIKLI SCOOTER"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "PIAGGIO": {
  "LIBERTY 125": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "LIBERTY 150": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MEDLEY 125": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MEDLEY 150": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "150 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "BEVERLY 300": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "278 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "BEVERLY 400": {
   "yil": 2001,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "399 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MP3 300": {
   "yil": 2006,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ÜÇ TEKERLEKLI SCOOTER"
   ],
   "motor": [
    "278 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "MP3 500": {
   "yil": 2006,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ÜÇ TEKERLEKLI SCOOTER"
   ],
   "motor": [
    "493 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  }
 },
 "BMW MOTORRAD": {
  "G 310 R": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "313 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "G 310 GS": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "313 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "F 750 GS": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "853 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "F 850 GS": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "853 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "F 900 R": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "895 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "F 900 GS": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "895 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "R 1250 GS": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1254 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "R 1300 GS": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1300 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "S 1000 RR": {
   "yil": 2009,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "999 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "S 1000 R": {
   "yil": 2014,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "999 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "S 1000 XR": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT TOURING"
   ],
   "motor": [
    "999 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "K 1600 GT": {
   "yil": 2011,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "TOURING"
   ],
   "motor": [
    "1649 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "R 18": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CRUISER"
   ],
   "motor": [
    "1802 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "CE 04": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ELEKTRIKLI SCOOTER"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "TEK ORANLI OTOMATIK"
   ]
  }
 },
 "KTM": {
  "DUKE 125": {
   "yil": 2011,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "DUKE 200": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "199 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "DUKE 390": {
   "yil": 2013,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "373 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "790 DUKE": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "799 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "890 DUKE R": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "889 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "1290 SUPER DUKE R": {
   "yil": 2014,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "1301 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "390 ADVENTURE": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "373 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "890 ADVENTURE": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "889 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "1290 SUPER ADVENTURE": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1301 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "KAWASAKI": {
  "NINJA 250": {
   "yil": 2008,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "249 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "NINJA 400": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "399 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "NINJA 650": {
   "yil": 2006,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "649 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "NINJA ZX-6R": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "636 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "NINJA ZX-10R": {
   "yil": 2004,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "998 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "Z400": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "399 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "Z650": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "649 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "Z900": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "948 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "VERSYS 650": {
   "yil": 2007,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "649 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "VERSYS 1000": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1043 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "QJ MOTOR": {
  "SRK 125": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SRK 250": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "249 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SRK 400": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "400 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SRK 700": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "693 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SRV 125": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CHOPPER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "SRT 550": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "554 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SRT 700": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "698 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "BENELLI": {
  "BN 125": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "LEONCINO 250": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED",
    "SCRAMBLER"
   ],
   "motor": [
    "249 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "LEONCINO 500": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED",
    "SCRAMBLER"
   ],
   "motor": [
    "500 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TRK 502": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "500 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TRK 702": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "698 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "502C": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CRUISER"
   ],
   "motor": [
    "500 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "KYMCO": {
  "AGILITY 50": {
   "yil": 2005,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "50 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "AGILITY 125": {
   "yil": 2005,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "LIKE 125": {
   "yil": 2009,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "PEOPLE S 200": {
   "yil": 2007,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SCOOTER"
   ],
   "motor": [
    "163 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "XCITING 400": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "399 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "AK 550": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "550 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  },
  "DOWNTOWN 350": {
   "yil": 2015,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "MAXI SCOOTER"
   ],
   "motor": [
    "321 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "CVT"
   ]
  }
 },
 "ROYAL ENFIELD": {
  "BULLET 350": {
   "yil": 2000,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CLASSIC"
   ],
   "motor": [
    "349 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "CLASSIC 350": {
   "yil": 2009,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CLASSIC"
   ],
   "motor": [
    "349 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "METEOR 350": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CRUISER"
   ],
   "motor": [
    "349 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "HIMALAYAN": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "411 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "HIMALAYAN 450": {
   "yil": 2023,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "452 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "INTERCEPTOR 650": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "648 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "CONTINENTAL GT 650": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CAFE RACER"
   ],
   "motor": [
    "648 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "HUSQVARNA": {
  "SVARTPILEN 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "VITPILEN 125": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "125 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SVARTPILEN 401": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "373 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "VITPILEN 401": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "373 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "NORDEN 901": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "889 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "701 ENDURO": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ENDURO"
   ],
   "motor": [
    "692 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "DUCATI": {
  "MONSTER 696": {
   "yil": 2008,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "696 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "MONSTER 797": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "803 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "MONSTER 937": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "937 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "PANIGALE V2": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "955 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "PANIGALE V4": {
   "yil": 2018,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "SPORT"
   ],
   "motor": [
    "1103 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "MULTISTRADA 950": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "937 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "MULTISTRADA V4": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1158 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "DIAVEL 1260": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CRUISER"
   ],
   "motor": [
    "1262 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "STREETFIGHTER V4": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "1103 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "TRIUMPH": {
  "STREET TRIPLE 675": {
   "yil": 2007,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "675 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "STREET TRIPLE 765": {
   "yil": 2017,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "765 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TRIDENT 660": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "NAKED"
   ],
   "motor": [
    "660 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TIGER 800": {
   "yil": 2011,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "799 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TIGER 900": {
   "yil": 2020,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "888 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "TIGER 1200": {
   "yil": 2012,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "ADVENTURE"
   ],
   "motor": [
    "1160 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "BONNEVILLE T100": {
   "yil": 2002,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CLASSIC"
   ],
   "motor": [
    "900 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "BONNEVILLE T120": {
   "yil": 2016,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CLASSIC"
   ],
   "motor": [
    "1200 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  },
  "SPEED TWIN 900": {
   "yil": 2019,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CLASSIC"
   ],
   "motor": [
    "900 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "5 İLERI MANUEL"
   ]
  },
  "ROCKET 3": {
   "yil": 2004,
   "paket": [
    "STANDARD",
    "PREMIUM",
    "TOURING"
   ],
   "kasa": [
    "CRUISER"
   ],
   "motor": [
    "2458 CC"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "6 İLERI MANUEL"
   ]
  }
 },
 "CADILLAC": {
  "DEVILLE": {
   "yil": 2000,
   "paket": [
    "BASE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "4.6L V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "SEVILLE": {
   "yil": 2000,
   "paket": [
    "SLS",
    "STS"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "4.6L V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ELDORADO": {
   "yil": 2000,
   "paket": [
    "BASE",
    "ETC"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "4.6L V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ESCALADE": {
   "yil": 2002,
   "paket": [
    "BASE",
    "LUXURY",
    "PREMIUM"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "5.3L V8",
    "6.2L V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ESCALADE EXT": {
   "yil": 2002,
   "paket": [
    "BASE",
    "LUXURY"
   ],
   "kasa": [
    "PICKUP"
   ],
   "motor": [
    "5.3L V8",
    "6.0L V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CTS": {
   "yil": 2002,
   "paket": [
    "BASE",
    "LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0T",
    "2.8 V6",
    "3.6 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK",
    "MANUEL"
   ]
  },
  "XLR": {
   "yil": 2003,
   "paket": [
    "BASE",
    "PLATINUM"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "4.6L V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "SRX": {
   "yil": 2004,
   "paket": [
    "BASE",
    "LUXURY",
    "PERFORMANCE"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "3.6 V6",
    "4.6 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "STS": {
   "yil": 2004,
   "paket": [
    "V6",
    "V8"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "3.6 V6",
    "4.6 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "DTS": {
   "yil": 2005,
   "paket": [
    "LUXURY",
    "PERFORMANCE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "4.6L V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ELR": {
   "yil": 2014,
   "paket": [
    "LUXURY"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "1.4 TURBO PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN + ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ATS": {
   "yil": 2012,
   "paket": [
    "LUXURY",
    "PERFORMANCE"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 TURBO",
    "3.6 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK",
    "MANUEL"
   ]
  },
  "XTS": {
   "yil": 2012,
   "paket": [
    "LUXURY",
    "PREMIUM"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "3.6 V6",
    "3.6 TWIN TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CT6": {
   "yil": 2015,
   "paket": [
    "LUXURY",
    "PREMIUM LUXURY",
    "PLATINUM"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 TURBO",
    "3.6 V6",
    "4.2 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "XT5": {
   "yil": 2016,
   "paket": [
    "LUXURY",
    "PREMIUM LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TURBO",
    "3.6 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "XT4": {
   "yil": 2018,
   "paket": [
    "LUXURY",
    "PREMIUM LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CT4": {
   "yil": 2020,
   "paket": [
    "LUXURY",
    "PREMIUM LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 TURBO",
    "2.7 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CT5": {
   "yil": 2020,
   "paket": [
    "LUXURY",
    "PREMIUM LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0 TURBO",
    "3.0 TWIN TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "XT6": {
   "yil": 2019,
   "paket": [
    "LUXURY",
    "PREMIUM LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TURBO",
    "3.6 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "LYRIQ": {
   "yil": 2023,
   "paket": [
    "LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "ESCALADE IQ": {
   "yil": 2025,
   "paket": [
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "OPTIQ": {
   "yil": 2025,
   "paket": [
    "LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "VISTIQ": {
   "yil": 2026,
   "paket": [
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CELESTIQ": {
   "yil": 2026,
   "paket": [
    "CUSTOM"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "CHANGAN": {
  "ALSVIN": {
   "yil": 2009,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.3",
    "1.4"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "BENBEN": {
   "yil": 2006,
   "paket": [
    "BASE",
    "COMFORT"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.0",
    "1.3"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "EADO": {
   "yil": 2012,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.5 TURBO",
    "1.6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CS35": {
   "yil": 2012,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CS75": {
   "yil": 2013,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO",
    "1.8 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CS15": {
   "yil": 2016,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CS55": {
   "yil": 2017,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "CS95": {
   "yil": 2017,
   "paket": [
    "LUXURY",
    "PREMIUM"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CS35 PLUS": {
   "yil": 2018,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.4 TURBO",
    "1.6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CS75 PLUS": {
   "yil": 2019,
   "paket": [
    "LUXURY",
    "PREMIUM"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CS85": {
   "yil": 2019,
   "paket": [
    "LUXURY"
   ],
   "kasa": [
    "SUV COUPE"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "UNI-T": {
   "yil": 2020,
   "paket": [
    "LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "UNI-K": {
   "yil": 2020,
   "paket": [
    "LUXURY",
    "FLAGSHIP"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "2.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "UNI-V": {
   "yil": 2022,
   "paket": [
    "LUXURY",
    "SPORT"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "1.5 TURBO",
    "2.0 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "LUMIN": {
   "yil": 2022,
   "paket": [
    "STANDARD",
    "PREMIUM"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "SL03": {
   "yil": 2022,
   "paket": [
    "PLUS",
    "MAX"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "ELEKTRIK",
    "HIBRIT"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "UNI-Z": {
   "yil": 2024,
   "paket": [
    "COMFORT",
    "LUXURY"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "1.5 TURBO",
    "PLUG-IN HYBRID"
   ],
   "yakit": [
    "BENZIN",
    "HIBRIT"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "CHRYSLER": {
  "300M": {
   "yil": 2000,
   "paket": [
    "BASE",
    "LHS"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.7 V6",
    "3.5 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "PT CRUISER": {
   "yil": 2000,
   "paket": [
    "CLASSIC",
    "TOURING",
    "LIMITED"
   ],
   "kasa": [
    "HATCHBACK"
   ],
   "motor": [
    "1.6",
    "2.0",
    "2.4 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "SEBRING": {
   "yil": 2000,
   "paket": [
    "LX",
    "TOURING",
    "LIMITED"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.0",
    "2.4",
    "2.7 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "VOYAGER": {
   "yil": 2000,
   "paket": [
    "LX",
    "SE",
    "LIMITED"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "2.4",
    "3.3 V6",
    "3.8 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "TOWN & COUNTRY": {
   "yil": 2000,
   "paket": [
    "LX",
    "TOURING",
    "LIMITED"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "3.3 V6",
    "3.8 V6",
    "4.0 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "CROSSFIRE": {
   "yil": 2004,
   "paket": [
    "BASE",
    "LIMITED",
    "SRT-6"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "3.2 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL",
    "OTOMATIK"
   ]
  },
  "300": {
   "yil": 2005,
   "paket": [
    "TOURING",
    "LIMITED",
    "SRT8"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.7 V6",
    "3.5 V6",
    "5.7 V8",
    "6.1 V8"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "PACIFICA": {
   "yil": 2004,
   "paket": [
    "LX",
    "TOURING",
    "LIMITED"
   ],
   "kasa": [
    "MPV"
   ],
   "motor": [
    "3.5 V6",
    "4.0 V6",
    "3.6 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "200": {
   "yil": 2011,
   "paket": [
    "LX",
    "TOURING",
    "LIMITED"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "2.4",
    "3.6 V6"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "CATERHAM": {
  "SEVEN 160": {
   "yil": 2014,
   "paket": [
    "160",
    "165"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "660 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "SEVEN 270": {
   "yil": 2014,
   "paket": [
    "270",
    "270R"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "1.6 TURBO"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "SEVEN 360": {
   "yil": 2015,
   "paket": [
    "360",
    "360R"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "SEVEN 420": {
   "yil": 2017,
   "paket": [
    "420",
    "420R"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "SEVEN 620": {
   "yil": 2014,
   "paket": [
    "620",
    "620R"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0 SUPERCHARGED"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  },
  "SEVEN 485": {
   "yil": 2014,
   "paket": [
    "485",
    "485R"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.0"
   ],
   "yakit": [
    "BENZIN"
   ],
   "sanziman": [
    "MANUEL"
   ]
  }
 },
 "CZINGER": {
  "21C": {
   "yil": 2021,
   "paket": [
    "STANDARD",
    "VMAX",
    "HDF"
   ],
   "kasa": [
    "COUPE"
   ],
   "motor": [
    "2.88L TWIN-TURBO V8 HYBRID"
   ],
   "yakit": [
    "HIBRIT"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "21C SPYDER": {
   "yil": 2024,
   "paket": [
    "SPYDER"
   ],
   "kasa": [
    "ROADSTER"
   ],
   "motor": [
    "2.88L TWIN-TURBO V8 HYBRID"
   ],
   "yakit": [
    "HIBRIT"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 },
 "CEER": {
  "EXOBOT SEDAN": {
   "yil": 2026,
   "paket": [
    "PLUS",
    "FIRST EDITION"
   ],
   "kasa": [
    "SEDAN"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  },
  "EXOBOT SUV": {
   "yil": 2026,
   "paket": [
    "PLUS",
    "FIRST EDITION"
   ],
   "kasa": [
    "SUV"
   ],
   "motor": [
    "ELEKTRIK"
   ],
   "yakit": [
    "ELEKTRIK"
   ],
   "sanziman": [
    "OTOMATIK"
   ]
  }
 }
};
